// api.js
// const BASE_URL = 'https://nirman.csdev.live/api/';
// const BASE_URL = 'http://43.241.69.44/nirman/api/';
// https://dev.siyaram.com/nirman/api/

import Swal from 'sweetalert2';
import { GARMENTUSER } from 'utils/constants';
import { clearAuthClientStorage, hasAuthenticatedUser, notifyAuthStateChanged } from 'utils/authSession';
// export let BASE_URL = '';
const TIMEOUT_DURATION = 8000;
const NODE_ENV = "Production";
// const NODE_ENV = 'development';
// export const BASE_URL = 'https://dev.siyaram.com/nirman/api/';
export const BASE_URL = 'https://sumaglobal.siyaram.com/nirman/api/';

// export const setBaseUrl = (server) => {
//   if(server === "1") {3...............
//     // BASE_URL = 'http://43.241.69.44/nirman/api/';
//     // BASE_URL = 'https://nirman.csdev.live/api/';
//     BASE_URL = 'https://dev.siyaram.com/nirman/api/';
//   } else if(server === "2") {
//     BASE_URL = 'https://sumaglobal.siyaram.com/nirman/api/';
//   } else {
//     BASE_URL = 'https://sumaglobal.siyaram.com/nirman/api/';
//   }

// };

// Retrieve selected server from localStorage if available
// const selectedServer = localStorage.getItem('server');
// if (selectedServer) {
//   console.log("Hello",selectedServer)
//   setBaseUrl(selectedServer);
// }

let isSessionExpiredHandling = false;
let refreshSessionPromise = null;
let restoreSessionPromise = null;
let nativeRefreshPromise = null;
let nativeRefreshResolver = null;
let nativeRefreshTimeoutId = null;

const isRunningInsideApp = () =>
  typeof window !== 'undefined' &&
  localStorage.getItem('isFromApp') === 'true' &&
  typeof window.SumaAuth?.postMessage === 'function';

const settleNativeRefresh = (success) => {
  if (nativeRefreshTimeoutId) {
    window.clearTimeout(nativeRefreshTimeoutId);
    nativeRefreshTimeoutId = null;
  }

  nativeRefreshResolver?.(success);
  nativeRefreshResolver = null;
};

if (typeof window !== 'undefined') {
  window.onFlutterTokenRefreshResult = (payload) => {
    try {
      const data = typeof payload === 'string' ? JSON.parse(payload) : payload;
      const accessToken = data?.accessToken || data?.token || '';
      const success = (data?.success === true || data?.success === 'true') && Boolean(accessToken);

      if (success) {
        localStorage.setItem('token', accessToken);
        localStorage.setItem('authenticated', 'true');
        notifyAuthStateChanged();
      }

      settleNativeRefresh(success);
    } catch (error) {
      settleNativeRefresh(false);
    }
  };
}

const requestFlutterTokenRefresh = () => {
  if (!isRunningInsideApp()) {
    return Promise.resolve(false);
  }

  if (nativeRefreshPromise) {
    return nativeRefreshPromise;
  }

  nativeRefreshPromise = new Promise((resolve) => {
    nativeRefreshResolver = resolve;
    nativeRefreshTimeoutId = window.setTimeout(() => {
      settleNativeRefresh(false);
    }, 15000);

    try {
      window.SumaAuth.postMessage(
        JSON.stringify({ type: 'REFRESH_TOKEN_REQUEST' })
      );
    } catch (error) {
      settleNativeRefresh(false);
    }
  }).finally(() => {
    nativeRefreshPromise = null;
  });

  return nativeRefreshPromise;
};

const clearClientSession = () => {
  clearCsrfToken();
  clearAuthClientStorage();
};

const callBackendLogout = async () => {
  try {
    await fetch(BASE_URL + 'logout.php', {
      method: 'POST',
      keepalive: true,
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...getAuthHeaders()
      },
      body: 'source=web'
    });
  } catch (error) {
    // Ignore logout cleanup errors; client session is cleared below.
  }
};

const handleSessionExpired = async (message = 'Session expired. Please login again.') => {
  if (isSessionExpiredHandling) {
    return;
  }

  isSessionExpiredHandling = true;
  const sessionExpiredMessage = message || 'Session expired. Please login again.';

  if (isRunningInsideApp()) {
    window.SumaAuth.postMessage(
      JSON.stringify({
        type: 'SESSION_EXPIRED',
        message: sessionExpiredMessage
      })
    );
    clearClientSession();
    return;
  }

  // Do not leave the protected screen mounted while logout.php completes.
  // Components on that screen may try to read the cleared user and crash.
  void callBackendLogout();
  clearClientSession();
  sessionStorage.setItem('sessionExpiredMessage', sessionExpiredMessage);
  window.location.replace('/login');
};

const showAlert = async (error) => {
  const swalResult = await Swal.fire({
    toast: true,
    position: 'bottom-end',
    title: error,
    icon: 'error',
    width: '420px',
    timerProgressBar: true,
    didOpen: () => {
      document.querySelector('.swal2-container')?.style.setProperty('z-index', '99999', 'important');
    },
    customClass: 'sweetalert-bootstrap-modal',
    timer: 4000,
    showConfirmButton: false
  });

  // If you want to perform some action after the alert is closed, you can check the result
  if (swalResult.dismiss === Swal.DismissReason.timer) {
    // console.log('Alert closed after the timer elapsed.');
    // Perform additional actions if needed
  }
};

const parseResponseJson = async (response) => {
  try {
    return await response.clone().json();
  } catch (error) {
    return null;
  }
};

const isAccessExpiredResponse = (response, data) => {
  const code = String(data?.code || '').toUpperCase();
  if (code === 'ACCESS_TOKEN_EXPIRED' || code === 'TOKEN_EXPIRED' || code === 'MISSING_AUTH_TOKEN') {
    return true;
  }

  return response.status === 401 && String(data?.msg || data?.message || '').toLowerCase().includes('access token expired');
};

const isSessionInvalidResponse = (response, data) => {
  return response.status === 401 || data?.code === 'SESSION_EXPIRED' || data?.code === 'ACCESS_TOKEN_EXPIRED' || data?.code === 'SESSION_REVOKED';
};

const isCsrfFailedResponse = (data) => {
  return data?.success === 'false' && String(data?.msg || '').toLowerCase().includes('csrf token validation failed');
};

export const refreshSession = async () => {
  if (refreshSessionPromise) {
    return refreshSessionPromise;
  }

  refreshSessionPromise = (async () => {
    try {
      if (isRunningInsideApp()) {
        return await requestFlutterTokenRefresh();
      }

      const response = await fetch(BASE_URL + 'refresh.php', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: ''
      });

      const data = await parseResponseJson(response);
      const responseCsrfToken = data?.csrfToken || response.headers.get('X-CSRF-Token');
      if (response.ok && (data?.success === 'true' || data?.success === true)) {
        if (responseCsrfToken) {
          setCsrfToken(responseCsrfToken);
        }

        const refreshedAccessToken = data?.accessToken || data?.token || '';
        const refreshedRefreshToken = data?.refreshToken || '';

        if (refreshedAccessToken) {
          localStorage.setItem('token', refreshedAccessToken);
        } else {
          // Web refresh uses the new HttpOnly access_token cookie. Do not let an
          // expired Authorization header override that fresh cookie on retry.
          localStorage.removeItem('token');
        }

        if (refreshedRefreshToken) {
          localStorage.setItem('refreshToken', refreshedRefreshToken);
        }

        return true;
      }

      return false;
    } catch (error) {
      return false;
    } finally {
      refreshSessionPromise = null;
    }
  })();

  return refreshSessionPromise;
};

export const restoreSession = async () => {
  if (hasAuthenticatedUser()) {
    return true;
  }

  if (restoreSessionPromise) {
    return restoreSessionPromise;
  }

  restoreSessionPromise = (async () => {
    const refreshed = await refreshSession();
    if (!refreshed) {
      return false;
    }

    try {
      const response = await fetchWithAuthRetry(BASE_URL + 'me.php', {
        method: 'POST',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          ...getAuthHeaders()
        },
        body: ''
      }, false);

      const data = await handleApiResponse(response);
      if ((data?.success === 'true' || data?.success === true) && data?.data?.[0]) {
        localStorage.setItem('user', JSON.stringify(data.data[0]));
        localStorage.setItem('loginMenu', JSON.stringify(data.menu || []));
        localStorage.setItem('role', data.data[0].userVerticalId || '');
        if (data.confvalue) {
          localStorage.setItem('confvalue', JSON.stringify(data.confvalue));
        }
        notifyAuthStateChanged();
        return true;
      }
    } catch (error) {
      return false;
    }

    return false;
  })();

  try {
    return await restoreSessionPromise;
  } finally {
    restoreSessionPromise = null;
  }
};

const fetchWithAuthRetry = async (url, options, retry = true) => {
  let response = await fetch(url, options);
  if (!retry) {
    return response;
  }

  // Refresh and replay the original request automatically. A second retry covers
  // browsers where the rotated HttpOnly cookie is not visible to the first replay.
  for (let attempt = 0; attempt < 2; attempt += 1) {
    const data = await parseResponseJson(response);
    if (!isAccessExpiredResponse(response, data) && !isCsrfFailedResponse(data)) {
      return response;
    }

    const refreshed = await refreshSession();
    if (!refreshed) {
      return response;
    }

    response = await fetch(url, {
      ...options,
      headers: {
        ...(options.headers || {}),
        ...getAuthHeaders()
      }
    });
  }

  return response;
};

const handleApiResponse = async (response) => {
  const headerCsrfToken = response.headers.get('X-CSRF-Token');
  let data = null;

  try {
    data = await response.json();
  } catch (error) {
    data = null;
  }

  const responseCsrfToken = data?.csrfToken || headerCsrfToken;
  if (responseCsrfToken) {
    setCsrfToken(responseCsrfToken);
  }

  if (isSessionInvalidResponse(response, data)) {
    await handleSessionExpired(data?.msg || data?.message);
    return data;
  }

  if (!response.ok) {
    //showAlert('Network response was not ok');
    return data;
  }

  return data;
};
export const handleUnauthorizedResponse = async (response) => {
  if (response.status !== 401) {
    return false;
  }

  let data = null;
  try {
    data = await response.clone().json();
  } catch (error) {
    data = null;
  }

  await handleSessionExpired(data?.msg || data?.message);
  return true;
};

const handleNetworkError = (error) => {
  // console.error('Check Error :' + error);
  if (error.name === "AbortError") {
    return; // ignore cancelled request
  }

  if (error.message.includes("NetworkError")) {
    return; // firefox temporary network retry
  }

  if (error.message.includes('Failed to fetch')) {
    showAlert('It seems that the connection to server has been lost.');
    return;
  }

  console.log("Error fetching data:", error.message);
};

const getTourExpenseUserType = (user = {}) => {
  const normalizedUserTypeId = String(user?.userTypeId || '').trim().toLowerCase();

  if (normalizedUserTypeId === 'ag' || normalizedUserTypeId === 'agent') {
    return 'AG';
  }

  const normalizedDesignation = Array.isArray(user?.designation)
    ? user.designation.map((value) => String(value || '').trim().toLowerCase()).join(' ')
    : JSON.stringify(user?.designation || '').toLowerCase();

  if (normalizedDesignation.includes('area sales officer')) {
    return 'SO';
  }

  if (normalizedUserTypeId === 'prim') {
    return 'SP';
  }

  return 'SP';
};

const getStoredCsrfToken = () => {
  return typeof window !== 'undefined' ? window.sessionStorage.getItem('csrfToken') || '' : '';
};

let csrfToken = getStoredCsrfToken();

export const setCsrfToken = (token) => {
  csrfToken = token || '';
  if (typeof window === 'undefined') {
    return;
  }

  if (csrfToken) {
    window.sessionStorage.setItem('csrfToken', csrfToken);
  } else {
    window.sessionStorage.removeItem('csrfToken');
  }
};

export const clearCsrfToken = () => {
  csrfToken = '';
  if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem('csrfToken');
  }
};

export const getCsrfHeaders = () => {
  const latestCsrfToken = getStoredCsrfToken() || csrfToken;
  csrfToken = latestCsrfToken || '';
  return csrfToken ? { 'X-CSRF-Token': csrfToken } : {};
};

export const getAuthHeaders = () => {
  const headers = { ...getCsrfHeaders() };
  const accessToken = localStorage.getItem('token');
  const deviceId = localStorage.getItem('deviceId');
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }
  if (deviceId) {
    headers['X-Device-Id'] = deviceId;
  }
  return headers;
};

const bodycontent = (body, url) => {
  if (!navigator.onLine) {
    throw new Error('No internet connection. Please check your network settings.');
  }
  return fetchWithAuthRetry(BASE_URL + url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...getAuthHeaders()
    },
    body: body,
    timeout: TIMEOUT_DURATION
  });
};

const bodycontentnormal = (body, url) => {
  if (!navigator.onLine) {
    throw new Error('No internet connection. Please check your network settings.');
  }
  return fetchWithAuthRetry(BASE_URL + url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...getAuthHeaders()
    },
    body: body,
    timeout: TIMEOUT_DURATION
  });
};

const bodycontentFormData = (body, url) => {
  console.log(body);
  console.log(url);

  if (!navigator.onLine) {
    throw new Error('No internet connection. Please check your network settings.');
  }

  return fetchWithAuthRetry(BASE_URL + url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...getAuthHeaders()
    },
    body: body,
    timeout: TIMEOUT_DURATION
  });
};

// const bodycontentJSON = (body, url) => {
//   console.log(body);
//   if (!navigator.onLine) {
//     throw new Error('No internet connection. Please check your network settings.');
//   }

//   return fetch(BASE_URL + url, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify(body),
//     timeout: TIMEOUT_DURATION
//   });
// };

const loginApi = async (confCode, userCode, password, deviceInfo, latitude, longitude) => {
  try {
    const response = await bodycontentnormal(`confCode=${confCode}&userCode=${userCode}&password=${password}&source=${'web'}&deviceInfo=${JSON.stringify(deviceInfo)}&latitude=${latitude}&longitude=${longitude}`, 'login.php');
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const logoutApi = async (userCode, source) => {
  try {
    const response = await bodycontentnormal(`userCode=${userCode}&deviceId=${null}&source=${source}`, 'logout.php');
    // console.error('Response:', response);
    const data = await handleApiResponse(response);
    clearCsrfToken();
    return data;
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchHeaderAnnouncement = async () => {
  try {
    const response = await bodycontentnormal('', 'getAnnouncement.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// const forgotPassApi = async (emailId, userCode) => {
//   try {
//     const response = await bodycontentnormal(`userEmailId=${emailId}&userCode=${userCode}`, 'forgotpassword.php');
//     // console.error('Response:', response);
//     return await handleApiResponse(response);
//   } catch (error) {
//     throw handleNetworkError(error);
//   }
// };

// Forgot Password API
const forgotPassApi = async (mobile, userCode) => {
  try {
    const response = await bodycontentnormal(`mobileNo=${mobile}&userCode=${userCode}`, 'otpgeneration.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// OTP Verification API
const otpVerificaionApi = async (mobile, userCode, otp) => {
  try {
    const response = await bodycontentnormal(`mobileNo=${mobile}&userCode=${userCode}&otp=${otp}`, 'otpverify.php');

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Reset Password API
const resetPasswordApi = async (resetToken, newPassword, options = {}) => {
  try {
    const params = new URLSearchParams();
    if (resetToken) params.append('resetToken', resetToken);
    params.append('newPassword', newPassword);
    if (options.isFirstLogin) params.append('isFirstLogin', 'true');
    if (options.userCode) params.append('userCode', options.userCode);
    const response = await bodycontentnormal(params.toString(), 'resetpassword.php');

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getConfData = async () => {
  try {
    // setBaseUrl(String(server));
    // if(String(server) !== '0')
    // {
    const response = await bodycontentnormal('', 'conference.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
    // }
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getCustomerData = async (userCode, searchText, retries = 3) => {
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));   // ✅ move here

  try {
    const response = await bodycontent(
      `cId=${confvalue?.cID}&userCode=${userCode}&searchVal=${searchText}`,
      'customer.php'
    );

    return await handleApiResponse(response);

  } catch (error) {
    const identifier = `${userCode}-${confvalue?.cID}`;
    await logErrorToApi(error.message, identifier);

    if (retries > 0) {
      console.warn(`Request failed. Retrying... (${retries} retries left)`);
      return await getCustomerData(userCode, searchText, retries - 1);
    } else {
      console.error('All retry attempts failed:', error);
      throw handleNetworkError(error);
    }
  }
};

const getCustomerStatusFromSap = async (partyCode, spart) => {
  try {
    const response = await bodycontent(
      `partyCode=${encodeURIComponent(partyCode || '')}&spart=${encodeURIComponent(spart || '')}`,
      'customerstatusfromsap.php'
    );

    // A 404 is a valid "No data found" response for this API and must not
    // replace the existing customer account status.
    return (await parseResponseJson(response)) || { success: false, data: [] };
  } catch (error) {
    return { success: false, data: [] };
  }
};

const getNonBilledCustomerData = async (userCode, searchText, retries = 3) => {
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));

  try {
    const response = await bodycontent(
      `cId=${confvalue?.cID}&userCode=${userCode}&searchVal=${searchText}`,
      'non_billed_customer.php'
    );

    return await handleApiResponse(response);

  } catch (error) {
    const identifier = `${userCode}-${confvalue?.cID}`;
    await logErrorToApi(error.message, identifier);

    if (retries > 0) {
      console.warn(`Request failed. Retrying... (${retries} retries left)`);
      return await getNonBilledCustomerData(userCode, searchText, retries - 1);
    } else {
      console.error('All retry attempts failed:', error);
      throw handleNetworkError(error);
    }
  }
};

const getCustomerLeadgerData = async (userCode, searchText, userVertical, retries = 3) => {
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));   // ✅ move here

  try {
    const response = await bodycontent(
      `cId=${confvalue?.cID}&userCode=${userCode}&searchVal=${searchText}&userVertical=${userVertical}`,
      'customerleadger.php'
    );

    return await handleApiResponse(response);

  } catch (error) {
    const identifier = `${userCode}-${confvalue?.cID}`;
    await logErrorToApi(error.message, identifier);

    if (retries > 0) {
      console.warn(`Request failed. Retrying... (${retries} retries left)`);
      return await getCustomerLeadgerData(userCode, searchText, userVertical, retries - 1);
    } else {
      console.error('All retry attempts failed:', error);
      throw handleNetworkError(error);
    }
  }
};


const getAgencyData = async (userCode, retries = 3) => {
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));   // ✅ move here

  try {
    const response = await bodycontent(
      `cId=${confvalue?.cID}&userCode=${userCode}`,
      'agencycode.php'
    );

    return await handleApiResponse(response);

  } catch (error) {
    const identifier = `${userCode}-${confvalue?.cID}`;
    await logErrorToApi(error.message, identifier);

    if (retries > 0) {
      console.warn(`Request failed. Retrying... (${retries} retries left)`);
      return await getAgencyData(userCode, retries - 1);
    } else {
      console.error('All retry attempts failed:', error);
      throw handleNetworkError(error);
    }
  }
};


const logErrorToApi = async (error, data) => {
  try {
    const response = await fetch(BASE_URL + 'log_error.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userCode: data,
        error: error || 'Unknown Error',
        stackTrace: 'No Stack Trace',
        deviceInfo: 'WEB' || 'No Device Info'
      })
    });

    if (response.ok) {
      //console.log("Error logged successfully.");
    } else {
      // console.error("Failed to log error.");
    }
  } catch (loggingError) {
    //console.error("Error logging to the API:", loggingError);
  }
};

const getDistributorData = async (userCode, searchText) => {
  try {
    const confvalue = JSON.parse(localStorage.getItem('confvalue'));
    const response = await bodycontent(`cId=${confvalue.cID}&userCode=${userCode}&searchVal=${searchText}`, 'distributor.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getTransportData = async () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const response = await bodycontent(`userCode=${user.userCode}`, 'transport.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDivisionData = async () => {
  try {
    const response = await bodycontent('', 'division.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getUserDivisionData = async (userCode) => {
  try {
    const response = await bodycontent(`userCode=${userCode}`, 'userdivision.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getCourierData = async () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const response = await bodycontent(`userCode=${user.userCode}`, 'courier.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getBarcodeScanData = async (
  partyCode,
  userId,
  customerId,
  barcode = '',
  userCode,
  verticalId,
  fullRange = '',
  multiBarcode = '',
  mainGroup = '',
  allSize = ''
) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const confvalue = JSON.parse(localStorage.getItem('confvalue')) || {};
    const distibutor = JSON.parse(localStorage.getItem('distributor'));
    const storedCustomer = JSON.parse(localStorage.getItem('customer')) || {};
    const headerCustomer = JSON.parse(localStorage.getItem('headerCustomer')) || {};
    const selectedCustomer = JSON.parse(localStorage.getItem('SelectedCustomer')) || {};
    const storedMaterialList = JSON.parse(localStorage.getItem('materialList'));
    const firstMaterial = storedMaterialList?.materialList?.[0] || {};
    const storedOrderDetails = JSON.parse(localStorage.getItem('orderupdatedList'));
    const firstOrderDetail = storedOrderDetails?.OrderDetails?.[0] || {};
    const resolvedPartyCode = partyCode || headerCustomer.partyCode || selectedCustomer.partyCode || storedCustomer.partyCode || firstMaterial.partyCode || firstOrderDetail.partyCode || '';
    const resolvedCustomerId =
      customerId ||
      headerCustomer.apId ||
      headerCustomer.customerId ||
      selectedCustomer.apId ||
      selectedCustomer.customerId ||
      storedCustomer.apId ||
      storedCustomer.customerId ||
      firstMaterial.apId ||
      firstMaterial.customerId ||
      firstOrderDetail.apId ||
      firstOrderDetail.customerId ||
      '';
    let filename = '';
    const normalizedVerticalId = String(verticalId || user.userVerticalId || '').toLowerCase();
    if (normalizedVerticalId.includes(GARMENTUSER.toLowerCase()) || normalizedVerticalId === 'den-gar') {
      filename = 'barcodescan.php';
    } else {
      filename = 'barcodescanfabric.php';
    }

    const payload = new URLSearchParams();
    payload.append('partyCode', resolvedPartyCode || '');
    payload.append('dPartyCode', distibutor?.value || '');
    payload.append('cId', confvalue?.cID || '');
    payload.append('userId', userId || '');
    payload.append('customerId', resolvedCustomerId || '');
    payload.append('div', user.confSpart || '');
    payload.append('barcode', barcode || '');
    payload.append('userCode', userCode || '');
    payload.append('verticalId', verticalId || '');
    payload.append('fullRange', fullRange || '');
    payload.append('multiBarcode', multiBarcode || '');
    payload.append('mainGroup', mainGroup || '');
    payload.append('allSize', allSize || '');

    const response = await bodycontent(payload.toString(), filename);
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const insertSalesPerformanceBarcodeScan = async (
  userCode,
  customerCode,
  barcode,
  verticalId,
  salesPerformerId,
  cId,
  dPartyCode,
  retailerName
) => {
  try {
    const response = await bodycontent(
      `userCode=${encodeURIComponent(userCode)}&customerCode=${encodeURIComponent(customerCode)}&barcode=${encodeURIComponent(barcode)}&verticalId=${encodeURIComponent(verticalId)}&salesPerformerId=${encodeURIComponent(salesPerformerId)}&cId=${encodeURIComponent(cId)}&dPartyCode=${encodeURIComponent(dPartyCode)}&retailerName=${encodeURIComponent(retailerName)}`,
      'salesPerfomerBarcodeScanInsert.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const updateSalesPerformanceBarcodeQuantityChecked = async (
  userCode,
  customerCode,
  materials,
  cId = '',
  dPartyCode = '',
  retailerName = ''
) => {
  try {
    const response = await bodycontent(
      `userCode=${encodeURIComponent(userCode)}&customerCode=${encodeURIComponent(customerCode)}&cId=${encodeURIComponent(
        cId
      )}&dPartyCode=${encodeURIComponent(dPartyCode)}&retailerName=${encodeURIComponent(retailerName)}&materials=${encodeURIComponent(
        JSON.stringify(materials)
      )}`,
      'salesPerfomerUpdateBarcodeQuantityChecked.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getSalesPerformerList = async (userCode, customerCode) => {
  try {
    const response = await bodycontent(
      `userCode=${encodeURIComponent(userCode)}&customerCode=${encodeURIComponent(customerCode)}`,
      'salesPerformerList.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getSalesPerfomerDetailsList = async (salesPerfomerId) => {
  try {
    const response = await bodycontent(`salesPerfomerId=${encodeURIComponent(salesPerfomerId)}`, 'salesPerfomerDetailsList.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getSalesPerfomerDetailsReportList = async (salesPerfomerId) => {
  try {  
    const response = await bodycontent(`salesPerfomerId=${encodeURIComponent(salesPerfomerId)}`, 'salesPerfomerDetailsReportList.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchSalesPerformanceReport = async ({ page, pageSize, userCode, customerCode, fromDate, toDate }) => {
  try {
    const payload = new URLSearchParams();
    payload.append('page', String(page || 1));
    payload.append('pageSize', String(pageSize || 100));
    payload.append('userCode', userCode || '');
    payload.append('customerCode', customerCode || '');
    payload.append('fromDate', fromDate || '');
    payload.append('toDate', toDate || '');

    const response = await bodycontent(payload.toString(), 'salesPerfomerReport.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const downloadSalesPerformerReportCsv = async (customerCode, fromDate, toDate, userCode) => {
  try {
    const response = await fetch(BASE_URL + 'salesPerfomerReportCsvDownload.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...getAuthHeaders()
      },
      credentials: 'include',
      body: `customerCode=${encodeURIComponent(customerCode || '')}&fromDate=${encodeURIComponent(fromDate || '')}&toDate=${encodeURIComponent(
        toDate || ''
      )}&userCode=${encodeURIComponent(userCode || '')}`
    });

    if (!response.ok) {
      await handleUnauthorizedResponse(response);
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const blob = await response.blob();
    const contentDisposition = response.headers.get('Content-Disposition');
    const now = new Date();
    const pad = (value) => String(value).padStart(2, '0');
    const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(
      now.getMinutes()
    )}${pad(now.getSeconds())}`;
    let filename = `SalesPerformerReport_${timestamp}.xls`;

    if (contentDisposition && contentDisposition.includes('filename=')) {
      const filenameMatch = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
      filename = filenameMatch ? decodeURIComponent(filenameMatch[1]) : contentDisposition.split('filename=')[1].replace(/["']/g, '');
    }

    const fileURL = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileURL;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(fileURL);

    return true;
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const salesPerfomerBarcodeScanFabric = async (
  partyCode,
  userId,
  customerId,
  barcode = '',
  userCode,
  verticalId = '',
  fullRange = '',
  multiBarcode = '',
  mainGroup = '',
  allSize = ''
) => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const confvalue = JSON.parse(localStorage.getItem('confvalue')) || {};
    const distibutor = JSON.parse(localStorage.getItem('distributor')) || {};

    const response = await bodycontent(
      `partyCode=${partyCode}&dPartyCode=${distibutor?.value || ''}&cId=${confvalue?.cID || ''}&userId=${userId}&customerId=${customerId}&div=${user.confSpart}&barcode=${barcode}&userCode=${userCode}&verticalId=${verticalId}&fullRange=${fullRange}&multiBarcode=${encodeURIComponent(
        multiBarcode
      )}&mainGroup=${encodeURIComponent(mainGroup)}&allSize=${encodeURIComponent(allSize)}`,
      'salesPerfomerBarcodeScanFabric.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const Order = async (mupdatedList, totalQuantity, orderType, orderNumber, ratioDropdownValue, ratioMultiplier, orderSource = 'NORMAL') => {
  const user = JSON.parse(localStorage.getItem('user'));
  const customer = JSON.parse(localStorage.getItem('customer')) || null;
  const distibutor = JSON.parse(localStorage.getItem('distributor'));
  const isRetrieve = JSON.parse(localStorage.getItem('isRetrieve'));
  const retailerName = JSON.parse(localStorage.getItem('retailerName'));
  // const location=JSON.parse(localStorage.getItem('location'));
  const mupdatedListjson = JSON.stringify(mupdatedList);
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));
  const materialList = JSON.parse(localStorage.getItem('materialList'));
  const salesPerfomerId = localStorage.getItem('salesPerfomerId') || '';
  const secondarySalesOrderNumber = localStorage.getItem('secondarySalesOrderNumber') || '';
  const denknitOrderNumber = localStorage.getItem('denknitOrderNumber') || '';
  const apId = customer == null ? materialList.materialList[0].apId : customer.apId;
  const orderfrom = localStorage.getItem('orderfrom');
  const orderEditByUserCode = orderfrom === 'Edit' ? user.userCode : '';
  const normalizedRatioDropdownValue = typeof ratioDropdownValue === 'object'
    ? ratioDropdownValue?.value
    : ratioDropdownValue;
  const normalizedRatioMultiplier = ratioMultiplier === '' || ratioMultiplier === null || ratioMultiplier === undefined
    ? 1
    : ratioMultiplier;
  // console.log("apId",apId);
  // console.log("mupdatedListjson==>"+mupdatedListjson);
  // console.log("orderNumber==>"+orderNumber+","+"user==>"+user+","+"customer==>"+customer+","+"distibutor==>"+distibutor+","+"location==>"+location
  // +","+"totalQuantity==>"+totalQuantity+","+"orderType==>"+orderType);

  const apiFile = String(confvalue.isSFA) === "1"
  ? "orderIsSfa.php"
  : "order.php";

  const isSFAValue = String(confvalue.isSFA) === "1" ? 1 : 0;
  console.log("isSecondaryOrder: " + localStorage.getItem('isSecondaryOrder'));
  // const isSecondaryOrder = JSON.parse(localStorage.getItem('isSecondaryOrder')) === "1" ? 1 : 0;
  const isSecondaryOrder = localStorage.getItem('isSecondaryOrder') === '1' ? 1 : 0;
  console.log("isSecondaryOrder: " + isSecondaryOrder);

  try {
    const response = await bodycontent(
      `cId=${confvalue.cID}&userId=${user.userId}&orderNumber=${orderNumber}&userCode=${user.userCode}&apId=${apId == 'undefined' ? '' : apId
      }&orderfrom=${orderfrom}&orderEditByUserCode=${encodeURIComponent(orderEditByUserCode)}&partyCode=${customer == null ? materialList.materialList[0].partyCode : customer.partyCode}&dPartyCode=${distibutor == null ? '' : distibutor.value
      }&retailerName=${retailerName}&div=${user.confSpart
      }&orderDetailsListArray=${encodeURIComponent(mupdatedListjson)}&totalQuantity=${totalQuantity}&orderType=${orderType}&orderSource=${encodeURIComponent(orderSource)}&isRetrieve=${isRetrieve == null ? 0 : isRetrieve
      }&appStatus=${'N'}&ratioDropdownValue=${normalizedRatioDropdownValue || null}&ratioMultiplier=${normalizedRatioMultiplier || 1}&orderIsSfa=${isSFAValue}${
        salesPerfomerId ? `&salesPerfomerId=${encodeURIComponent(salesPerfomerId)}` : ''
      }&secondarySalesOrderNumber=${encodeURIComponent(secondarySalesOrderNumber)}&denknitOrderNumber=${encodeURIComponent(denknitOrderNumber)}&isSecondaryOrder=${isSecondaryOrder}`,
      // 'order.php'
      apiFile
    );

    // console.error('Response:', response);
    localStorage.setItem('isSecondaryOrder', '0');

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const CheckoutOrder = async (orderScheduleArray, orderType, formData) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const customer = JSON.parse(localStorage.getItem('customer'));
  //const location=JSON.parse(localStorage.getItem('location'));
  const orderScheduleArrayjson = JSON.stringify(orderScheduleArray);
  const orderId = localStorage.getItem('ordernumber');
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));
  const materialList = JSON.parse(localStorage.getItem('materialList'));

  try {
    const response = await bodycontent(
      `cId=${confvalue.cID}&userCode=${user.userCode}&partyCode=${customer == null ? materialList.materialList[0].partyCode : customer.partyCode
      }&orderId=${orderId}&dispatchReason=${formData.dispatchReason.value}&orderScheduleArray=${orderScheduleArrayjson}&name=${formData.name}&emailId=${formData.email}&mobileNo=${formData.mobile}&note=${formData.note
      }&orderType=${orderType}`,
      'checkoutorder.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const FabricCheckoutOrder = async (formData, orderType) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const customer = JSON.parse(localStorage.getItem('customer'));
  //const location=JSON.parse(localStorage.getItem('location'));
  const orderId = localStorage.getItem('ordernumber');
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));
  const isOrderScheduleEnabled = Number(confvalue?.isOrderScheduleEnable) === 1;
  const materialList = JSON.parse(localStorage.getItem('materialList'));
  const scheduledData = JSON.parse(localStorage.getItem('scheduledData')) || [];
  // const updatedScheduledData = scheduledData.map((item) => ({
  //   ...item,
  //   scheduleDate: item.scheduleDate ? item.scheduleDate.split('T')[0] : item.scheduleDate
  // }));
  const toLocalDateString = (isoString) => {
    const d = new Date(isoString);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const updatedScheduledData = scheduledData.map((item) => ({
    ...item,
    scheduleDate: item.scheduleDate ? toLocalDateString(item.scheduleDate) : item.scheduleDate
  }));
  
  const orderScheduleArray = { OrderSchedule: updatedScheduledData };
  const orderScheduleParam = isOrderScheduleEnabled
    ? `&orderScheduleArray=${encodeURIComponent(JSON.stringify(orderScheduleArray))}`
    : '';
  // console.log("customer",customer)
  try {
    const response = await bodycontent(
      `userCode=${user.userCode}&partyCode=${customer == null ? materialList.materialList[0].partyCode : customer.partyCode}&cId=${confvalue.cID
      }&orderId=${orderId}&dispatchWeek=${formData.dispatchWeek.value}&dispatchMonth=${formData.dispatchMonth.label + ' ' + formData.dispatchYear.value
      }&dispatchStatus=${formData.dispatchStatus}&dispatchReason=${formData.dispatchReason.value}&note=${formData.note}&emailId=${formData.emailId
      }&mobileNo=${formData.mobile}&sampleRequired=${formData.sampleRequired}&orderType=${orderType}&blackRequired=${formData.blackRequired}${orderScheduleParam}`,
      'checkoutorder.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getOrdersData = async (userCode, apId) => {
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));

  try {
    const response = await bodycontent(`userCode=${userCode}&cId=${confvalue.cID}&partyCode=${apId}`, 'orderlist.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getSalesOrderCustomerTargetData = async (userCode, partyCode) => {
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));
  
  try {
    const response = await bodycontent(
      `userCode=${userCode}&confCode=${confvalue?.value || ''}&partyCode=${partyCode}`,
      'get_party_target_summary.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getOrderDetails = async (orderId) => {
  try {
    const response = await bodycontent(`orderId=${orderId}`, 'orderdetails.php');
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getReplicateOrderDetails = async (orderId) => {
  try {
    const response = await bodycontent(`orderId=${orderId}`, 'orderdetailsreplicate.php');
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getRetriveDetails = async (partyCode, materialVertical) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const response = await bodycontent(
      `userCode=${user.userCode}&partyCode=${partyCode}&materialVertical=${materialVertical}`,
      'retrievelist.php'
    );
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getOrderReasonData = async () => {
  try {
    const response = await bodycontent('', 'orderreasonlist.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const downalodFabricPdf = async (orderId, orderNumber, fileName) => {
  try {
    const response = await fetch(BASE_URL + fileName, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...getAuthHeaders()
      },
      credentials: 'include',
      body: `orderId=${orderId}`
    });

    if (!response.ok) {
      await handleUnauthorizedResponse(response);
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const blob = await response.blob();

    // Create a link element and trigger a download
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = orderNumber + '.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Return true when the download is complete
    return true;
  } catch (error) {
    // console.error('Error downloading PDF:', error);
    throw new Error('Download failed');
  }
};

const attedancereportData = async () => {
  const user = JSON.parse(localStorage.getItem('user'));

  try {
    const response = await bodycontent(`userId=${user.userId}`, 'myattendancereport.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const myordersreportData = async (conferenceFilter, customerFilter, orderNumberFilter, orderDateFilter, page = 1, pageSize = 50) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));

  // Extract values safely
  let conference = conferenceFilter?.value || '';
  const customer = customerFilter?.value || '';
  const orderNumber = orderNumberFilter || '';
  const orderDate = orderDateFilter || '';

  if (conference == "123") {
    conference = '';
  }


  try {
    const response = await bodycontent(
      `userCode=${user.userCode}` +
      `&cId=${confvalue.cID}` +
      `&cIdFilter=${conference}` +
      `&partyCodeFilter=${customer}` +
      `&orderNumber=${orderNumber}` +
      `&orderCreateddate=${orderDate}` +
      `&page=${page}` +
      `&pageSize=${pageSize}`,
      'myorderreport.php'
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDenknitOrderList = async (filters = {}) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const confvalue = JSON.parse(localStorage.getItem('confvalue') || '{}');
  const isDistributor = String(user?.userTypeId || '').trim().toUpperCase() === 'DIST';
  const requestUserCode = isDistributor ? '' : user?.userCode || '';
  const requestPartyCodeFilter = isDistributor ? user?.userCode || '' : filters?.partyCodeFilter || '';

  try {
    const response = await bodycontent(
      `userCode=${encodeURIComponent(requestUserCode)}` +
        `&cId=${encodeURIComponent(confvalue?.cID || '')}` +
        `&idFilter=${encodeURIComponent(filters?.idFilter || '')}` +
        `&partyCodeFilter=${encodeURIComponent(requestPartyCodeFilter)}` +
        `&fromDate=${encodeURIComponent(filters?.fromDate || '')}` +
        `&toDate=${encodeURIComponent(filters?.toDate || '')}` +
        `&status=${encodeURIComponent(filters?.status || '')}` +
        `&orderNumber=${encodeURIComponent(filters?.orderNumber || '')}`,
      'denknit/denknit_orderlist.php'
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getSecondarySalesOrderList = async (filters = {}) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  try {
    const response = await bodycontent(
      `userCode=${encodeURIComponent(filters?.userCode !== undefined ? filters.userCode : (user?.userCode || ''))}` +
        `&partyCode=${encodeURIComponent(filters?.partyCode || '')}` +
        `&fromDate=${encodeURIComponent(filters?.fromDate || '')}` +
        `&toDate=${encodeURIComponent(filters?.toDate || '')}` +
        `&page=${encodeURIComponent(filters?.page || 1)}` +
        `&pageSize=${encodeURIComponent(filters?.pageSize || 50)}`,
      'secondarysalesorder/get_secondary_sales_order_list.php'
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getSecondarySalesOrderDetails = async (orderId) => {
  try {
    const response = await bodycontent(
      `orderId=${encodeURIComponent(orderId || '')}`,
      'secondarysalesorder/get_secondary_sales_order_details.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const updateSecondarySalesOrderStockType = async ({ updatedBy = '', stockData = [] } = {}) => {
  try {
    const response = await bodycontent(
      `updatedBy=${encodeURIComponent(updatedBy)}` +
        `&stockData=${encodeURIComponent(JSON.stringify(stockData))}`,
      'secondarysalesorder/update_stock_type.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const createSalesOrderFromSecondary = async ({ secondarySalesOrderNumber = '', order = {}, materials = [] } = {}) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const confvalue = JSON.parse(localStorage.getItem('confvalue') || '{}');
  const isSFA = String(confvalue?.isSFA) === '1';
  const orderType = order?.orderType || materials[0]?.orderType ||
    (String(user?.userVerticalId || '').toLowerCase().includes(GARMENTUSER.toLowerCase()) ? 'Garment' : 'Fabric');
  const totalQuantity = materials.reduce((sum, item) => sum + (Number(item.qty) || 0), 0);
  const orderDetailsListArray = JSON.stringify({ OrderDetails: materials });
  const apiFile = isSFA ? 'orderIsSfa.php' : 'order.php';

  try {
    const response = await bodycontent(
      `cId=${encodeURIComponent(confvalue?.cID || '')}` +
        `&userId=${encodeURIComponent(user?.userId || '')}` +
        `&orderNumber=` +
        `&userCode=${encodeURIComponent(user?.userCode || '')}` +
        `&apId=${encodeURIComponent(materials[0]?.apId || '')}` +
        `&orderfrom=` +
        `&orderEditByUserCode=` +
        `&partyCode=${encodeURIComponent(order?.partyCode || '')}` +
        `&dPartyCode=` +
        `&retailerName=${encodeURIComponent(order?.retailerName || '')}` +
        `&div=${encodeURIComponent(user?.confSpart || '')}` +
        `&orderDetailsListArray=${encodeURIComponent(orderDetailsListArray)}` +
        `&totalQuantity=${encodeURIComponent(totalQuantity)}` +
        `&orderType=${encodeURIComponent(orderType)}` +
        `&isRetrieve=0&appStatus=N&ratioDropdownValue=&ratioMultiplier=1` +
        `&orderIsSfa=${isSFA ? 1 : 0}` +
        `&secondarySalesOrderNumber=${encodeURIComponent(secondarySalesOrderNumber)}`,
      apiFile
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getSecondarySalesBarcodeData = async ({ partyCode = '', customerId = '', barcode = '', multiBarcode = '', mainGroup = '' } = {}) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const confvalue = JSON.parse(localStorage.getItem('confvalue') || '{}');
  const verticalId = String(user?.userVerticalId || '');
  const filename = verticalId.toLowerCase().includes(GARMENTUSER.toLowerCase())
    ? 'secondarysalesorder/secondary_barcodescan.php'
    : 'secondarysalesorder/secondary_barcodescanfabric.php';

  try {
    const response = await bodycontent(
      `partyCode=${encodeURIComponent(partyCode)}` +
        `&cId=${encodeURIComponent(confvalue?.cID || '')}` +
        `&userId=${encodeURIComponent(user?.userId || '')}` +
        `&customerId=${encodeURIComponent(customerId)}` +
        `&div=${encodeURIComponent(user?.confSpart || '')}` +
        `&barcode=${encodeURIComponent(barcode)}` +
        `&userCode=${encodeURIComponent(user?.userCode || '')}` +
        `&verticalId=${encodeURIComponent(verticalId)}` +
        `&fullRange=` +
        `&multiBarcode=${encodeURIComponent(multiBarcode)}` +
        `&mainGroup=${encodeURIComponent(mainGroup)}` +
        `&allSize=`,
      filename
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const saveSecondarySalesOrder = async ({ order = {}, materials = [] } = {}) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const confvalue = JSON.parse(localStorage.getItem('confvalue') || '{}');
  let savedLocation = {};
  try {
    savedLocation = JSON.parse(localStorage.getItem('location') || '{}') || {};
  } catch (error) {
    savedLocation = {};
  }
  const orderLatitude = savedLocation?.latitude || '';
  const orderLongitude = savedLocation?.longitude || '';
  const orderDetailsListArray = JSON.stringify({ OrderDetails: materials });

  try {
    const response = await bodycontent(
      `orderNumber=${encodeURIComponent(order?.orderNumber || '')}` +
        `&userCode=${encodeURIComponent(user?.userCode || '')}` +
        `&userId=${encodeURIComponent(user?.userId || '')}` +
        `&partyCode=${encodeURIComponent(order?.partyCode || '')}` +
        `&retailerName=${encodeURIComponent(order?.retailerName || '')}` +
        `&city=${encodeURIComponent(order?.city || '')}` +
        `&contactNo=${encodeURIComponent(order?.contactNo || '')}` +
        `&totalQuantity=${encodeURIComponent(order?.totalQuantity || 0)}` +
        `&email=${encodeURIComponent(order?.email || '')}` +
        `&cId=${encodeURIComponent(confvalue?.cID || '')}` +
        `&orderLatitude=${encodeURIComponent(orderLatitude || '')}` +
        `&orderLongitude=${encodeURIComponent(orderLongitude || '')}` +
        `&orderDetailsListArray=${encodeURIComponent(orderDetailsListArray)}`,
      'secondarysalesorder/secondary_sales_oder.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDenknitOrderDetails = async (orderId) => {
  try {
    const response = await bodycontent(`orderId=${encodeURIComponent(orderId || '')}`, 'denknit/denknit_orderdetails.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const approveDenknitOrderItem = async ({ orderDtlsId = '', action = 'approve' } = {}) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  try {
    const response = await bodycontent(
      `orderDtlsId=${encodeURIComponent(orderDtlsId || '')}` +
        `&action=${encodeURIComponent(action || 'approve')}` +
        `&userCode=${encodeURIComponent(user?.userCode || '')}`,
      'denknit/denknit_item_approval.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDenknitTimeline = async ({ orderId = '', orderNumber = '' } = {}) => {
  try {
    const response = await bodycontent(
      `orderId=${encodeURIComponent(orderId || '')}` +
        `&orderNumber=${encodeURIComponent(orderNumber || '')}`,
      'denknit/denknit_timeline.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const updateDenknitCustomerApproval = async ({
  orderId = '',
  customerApprovalStatus = '',
  customerRejectionReason = ''
} = {}) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  try {
    const response = await bodycontent(
      `orderId=${encodeURIComponent(orderId || '')}` +
        `&customerApprovalStatus=${encodeURIComponent(customerApprovalStatus || '')}` +
        `&customerRejectionReason=${encodeURIComponent(customerRejectionReason || '')}` +
        `&userCode=${encodeURIComponent(user?.userCode || '')}`,
      'denknit/denknit_customer_approval.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDenknitBarcodeScanData = async ({
  partyCode = '',
  customerId = '',
  barcode = '',
  verticalId = '',
  fullRange = '',
  multiBarcode = '',
  mainGroup = '',
  allSize = ''
} = {}) => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const confvalue = JSON.parse(localStorage.getItem('confvalue') || {});
    const effectiveVerticalId = String(verticalId || user?.userVerticalId || '');
    const normalizedVerticalId = effectiveVerticalId.toLowerCase();
    const filename = normalizedVerticalId.includes(GARMENTUSER.toLowerCase()) || normalizedVerticalId === 'den-gar'
      ? 'denknit/denknit_barcodescan.php'
      : 'denknit/denknit_barcodescanfabric.php';

    const response = await bodycontent(
      `partyCode=${encodeURIComponent(partyCode || '')}` +
        `&cId=${encodeURIComponent(confvalue?.cID || '')}` +
        `&userId=${encodeURIComponent(user?.userId || '')}` +
        `&customerId=${encodeURIComponent(customerId || '')}` +
        `&div=${encodeURIComponent(user?.confSpart || '')}` +
        `&barcode=${encodeURIComponent(barcode || '')}` +
        `&userCode=${encodeURIComponent(user?.userCode || '')}` +
        `&verticalId=${encodeURIComponent(effectiveVerticalId || '')}` +
        `&fullRange=${encodeURIComponent(fullRange || '')}` +
        `&multiBarcode=${encodeURIComponent(multiBarcode || '')}` +
        `&mainGroup=${encodeURIComponent(mainGroup || '')}` +
        `&allSize=${encodeURIComponent(allSize || '')}`,
      filename
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// const saveDenknitOrder = async ({ record = {}, materials = [], orderType = '' } = {}) => {
//   const user = JSON.parse(localStorage.getItem('user') || '{}');
//   const confvalue = JSON.parse(localStorage.getItem('confvalue') || {});
//   const normalizedOrderType = String(orderType || record?.orderType || '').trim();
//   const getSampleTypeName = (sampleType) => {
//     if (!sampleType) return '';
//     if (typeof sampleType === 'object') {
//       return sampleType.label || sampleType.sampleTypeName || sampleType.value || '';
//     }
//     return String(sampleType || '').trim();
//   };
//   const orderDetails = (Array.isArray(materials) ? materials : []).map((item) => ({
//     materialID: item.materialID || '',
//     materialCode: item.materialCode || '',
//     materialDesc: item.materialDesc || '',
//     mainGroup: item.mainGroup || '',
//     barcode: item.barcode || '',
//     sizex: item.sizex || item.size || '',
//     chart: item.chart || '',
//     shade: item.shade || '',
//     customShadeName: item.customShadeName || '',
//     grade: item.grade || '',
//     orgDivision: item.orgDivision || '',
//     MRP: item.MRP || '',
//     materialVertical: item.materialVertical || normalizedOrderType,
//     stockType: item.stockType || '',
//     sampleType: getSampleTypeName(item.sampleType),
//     customShadeName: String(item.customShadeName || '').trim(),
//     qty: item.qty || 0,
//     remark: item.note || item.remark || ''
//   }));

//   const totalQuantity = orderDetails.reduce((sum, item) => sum + (Number(item.qty) || 0), 0);
//   const orderDetailsListArray = JSON.stringify({ OrderDetails: orderDetails });
//   const isEdit = Boolean(record?.orderId);

//   try {
//     const response = await bodycontent(
//       `cId=${encodeURIComponent(confvalue?.cID || '')}` +
//         `&userId=${encodeURIComponent(user?.userId || '')}` +
//         `&orderNumber=${encodeURIComponent(isEdit ? record.orderId : '')}` +
//         `&userCode=${encodeURIComponent(user?.userCode || '')}` +
//         `&apId=${encodeURIComponent(record?.apId || record?.customerId || '')}` +
//         `&orderfrom=${encodeURIComponent(isEdit ? 'Edit' : '')}` +
//         `&partyCode=${encodeURIComponent(record?.partyCode || '')}` +
//         `&email=${encodeURIComponent(record?.email || record?.emailId || '')}` +
//         `&mobileNo=${encodeURIComponent(record?.mobile || '')}` +
//         `&city=${encodeURIComponent(record?.city || '')}` +
//         `&address=${encodeURIComponent(record?.address || '')}` +
//         `&description=${encodeURIComponent(record?.sortDescription || '')}` +
//         `&div=${encodeURIComponent(user?.confSpart || '')}` +
//         `&exportDivision=${encodeURIComponent(record?.exportDivisionRequest ? '1' : '0')}` +
//         `&orderLatitude=${encodeURIComponent(record?.orderLatitude || '')}` +
//         `&orderLongitude=${encodeURIComponent(record?.orderLongitude || '')}` +
//         `&orderLocation=${encodeURIComponent(record?.orderLocation || '')}` +
//         `&orderDetailsListArray=${encodeURIComponent(orderDetailsListArray)}` +
//         `&totalQuantity=${encodeURIComponent(totalQuantity)}` +
//         `&orderType=${encodeURIComponent(normalizedOrderType)}` +
//         `&appStatus=N`,
//       'denknit/denknit_order.php'
//     );

//     return await handleApiResponse(response);
//   } catch (error) {
//     throw handleNetworkError(error);
//   }
// };

const saveDenknitOrder = async ({ record = {}, materials = [], orderType = '' } = {}) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const confvalue = JSON.parse(localStorage.getItem('confvalue') || {});
  const normalizedOrderType = String(orderType || record?.orderType || '').trim();

  const getSampleTypeName = (sampleType) => {
    if (!sampleType) return '';
    if (typeof sampleType === 'object') {
      return sampleType.label || sampleType.sampleTypeName || sampleType.value || '';
    }
    return String(sampleType || '').trim();
  };

  const sourceMaterials = Array.isArray(materials) ? materials : [];
  const hasBrowserFile = (file) => typeof File !== 'undefined' && file instanceof File;
  const getImageGroupKey = (item) => `${String(item?.materialCode || '').trim()}|${String(item?.shade || '').trim()}`;
  const imageUploads = new Map();
  sourceMaterials.forEach((item) => {
    if (!hasBrowserFile(item.imageFile)) return;
    const groupKey = getImageGroupKey(item);
    if (!imageUploads.has(groupKey)) {
      imageUploads.set(groupKey, {
        imageKey: `material_image_${imageUploads.size}`,
        file: item.imageFile
      });
    }
  });

  const orderDetails = sourceMaterials.map((item) => ({
      materialID: item.materialID || '',
      materialCode: item.materialCode || '',
      materialDesc: item.materialDesc || '',
      mainGroup: item.mainGroup || '',
      barcode: item.barcode || '',
      sizex: item.sizex || item.size || '',
      chart: item.chart || '',
      shade: item.shade || '',
      customShadeName: String(item.customShadeName || '').trim(),
      grade: item.grade || '',
      orgDivision: item.orgDivision || '',
      MRP: item.MRP || '',
      materialVertical: item.materialVertical || normalizedOrderType,
      stockType: item.stockType || '',
      sampleType: getSampleTypeName(item.sampleType),
      qty: item.qty || 0,
      remark: item.note || item.remark || '',
      imagePath: item.imagePath || '',
      imageKey: imageUploads.get(getImageGroupKey(item))?.imageKey || null
    }));

  const totalQuantity = orderDetails.reduce((sum, item) => sum + (Number(item.qty) || 0), 0);
  const orderDetailsListArray = JSON.stringify({ OrderDetails: orderDetails });
  const isEdit = Boolean(record?.orderId);

  try {
    const requestBody = new FormData();
    const requestFields = {
      cId: confvalue?.cID || '',
      userId: user?.userId || '',
      orderNumber: isEdit ? record.orderId : '',
      userCode: user?.userCode || '',
      apId: record?.apId || record?.customerId || '',
      orderfrom: isEdit ? 'Edit' : '',
      partyCode: record?.partyCode || '',
      email: record?.email || record?.emailId || '',
      mobileNo: record?.mobile || '',
      city: record?.city || '',
      address: record?.address || '',
      description: record?.sortDescription || '',
      div: user?.confSpart || '',
      exportDivision: record?.exportDivisionRequest ? '1' : '0',
      orderLatitude: record?.orderLatitude || '',
      orderLongitude: record?.orderLongitude || '',
      orderLocation: record?.orderLocation || '',
      orderDetailsListArray,
      totalQuantity,
      orderType: normalizedOrderType,
      appStatus: 'N'
    };

    Object.entries(requestFields).forEach(([fieldName, fieldValue]) => {
      requestBody.append(fieldName, String(fieldValue ?? ''));
    });
    imageUploads.forEach(({ imageKey, file }) => {
      requestBody.append(imageKey, file, file.name);
    });

    const response = await bodycontentFormData(requestBody, 'denknit/denknit_order.php');

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const checkDenknitApprovalStatus = async (orderNumber) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const confvalue = JSON.parse(localStorage.getItem('confvalue') || {});

  try {
    const response = await bodycontent(
      `cId=${encodeURIComponent(confvalue?.cID || '')}` +
        `&userCode=${encodeURIComponent(user?.userCode || '')}` +
        `&orderNumber=${encodeURIComponent(orderNumber || '')}` +
        `&checkApprovalStatus=1`,
      'denknit/denknit_order.php'
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const DenknitCheckoutOrder = async (formData, orderType = 'fabric', record = {}, orderScheduleArray = null) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const confvalue = JSON.parse(localStorage.getItem('confvalue') || {});
  const currentRecord =
    record ||
    JSON.parse(localStorage.getItem('DenknitSampleProcessCurrent') || 'null') ||
    {};
  const orderScheduleArrayjson = orderScheduleArray ? JSON.stringify(orderScheduleArray) : '';

  try {
    const response = await bodycontent(
      `userCode=${encodeURIComponent(user?.userCode || '')}` +
        `&partyCode=${encodeURIComponent(currentRecord?.partyCode || '')}` +
        `&cId=${encodeURIComponent(confvalue?.cID || '')}` +
        `&orderId=${encodeURIComponent(currentRecord?.orderId || currentRecord?.id || '')}` +
        `&orderLatitude=${encodeURIComponent(currentRecord?.orderLatitude || '')}` +
        `&orderLongitude=${encodeURIComponent(currentRecord?.orderLongitude || '')}` +
        `&orderLocation=${encodeURIComponent(currentRecord?.orderLocation || '')}` +
        `&dispatchWeek=${encodeURIComponent(formData?.dispatchWeek?.value || '')}` +
        `&dispatchMonth=${encodeURIComponent(
          formData?.dispatchMonth?.label && formData?.dispatchYear?.value
            ? `${formData.dispatchMonth.label} ${formData.dispatchYear.value}`
            : ''
        )}` +
        `&dispatchStatus=${encodeURIComponent(formData?.dispatchStatus || '')}` +
          `&dispatchReason=${encodeURIComponent(formData?.dispatchReason?.value || '')}` +
          `&orderReasonCode=${encodeURIComponent(formData?.dispatchReason?.value || '')}` +
        `&note=${encodeURIComponent(formData?.note || '')}` +
          `&emailId=${encodeURIComponent(formData?.emailId || formData?.email || '')}` +
        `&orderType=${encodeURIComponent(orderType || 'fabric')}` +
        `&orderScheduleArray=${encodeURIComponent(orderScheduleArrayjson)}`,
      'denknit/denknit_checkoutorder.php'
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};


// const CustomerProfileApi = async (formData) => {

//   try {
//     const user=JSON.parse(localStorage.getItem('user'));
//     const response = await bodycontent(`userCode=${user.userCode}&gstInNumber=${formData.gstInNumber}&uploaded_file_gst=${formData.uploaded_file_gst}&customerName=${formData.customerName}&address1=${formData.address1}&address2=${formData.address2}&address3=${formData.address3}&pinCode=${formData.pinCode}&city=${formData.city}&district=${formData.district}&state=${formData.state}&contactPersonFullName=${formData.contactPersonFullName}&telephoneNumber=${formData.telephoneNumber}&mobileNo=${formData.mobileNo}&billTo=${formData.billTo.value}&payTo=${formData.payTo.value}&emailAddress=${formData.emailAddress}&panNumber=${formData.panNumber}&uploaded_file_pan=${formData.uploaded_file_pan}&aadharNumber=${formData.aadharNumber}&uploaded_file_aadhar=${formData.uploaded_file_aadhar}&salesOfficerName=${formData.salesOfficerName}&transportName=${formData.transportName.value}&courierName=${formData.courierName.value}&transportDestinationFrom=${formData.transportDestinationFrom.value}&transportDestinationTo=${formData.transportDestinationTo}&maxCaseOneLr=${formData.maxCaseOneLr.value}&customerCategory=${formData.customerCategory.value}&bankName=${formData.bankName}&bankBranchAddress=${formData.bankBranchAddress}&bankAccountNumber=${formData.bankAccountNumber}&ifscCode=${formData.ifscCode}&micrCode=${formData.micrCode}`,'customerprofile.php');

//     // console.error('Response:', response);

//     return await handleApiResponse(response);
//   } catch (error) {
//     throw handleNetworkError(error);
//   }
// };

const CustomerProfileApi = async (formData) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const requestBody = new FormData();

    // Append form fields to FormData
    requestBody.append('userCode', user.userCode);
    requestBody.append('gstInNumber', formData.gstInNumber);
    requestBody.append('customerName', formData.customerName);
    requestBody.append('address1', formData.address1);
    requestBody.append('address2', formData.address2);
    requestBody.append('address3', formData.address3);
    requestBody.append('pinCode', formData.pinCode);
    requestBody.append('city', formData.city);
    requestBody.append('district', formData.district);
    requestBody.append('state', formData.state);
    requestBody.append('contactPersonFullName', formData.contactPersonFullName);
    requestBody.append('telephoneNumber', formData.telephoneNumber);
    requestBody.append('mobileNo', formData.mobileNo);
    requestBody.append('billTo', formData.billTo ? formData.billTo.value : '');
    requestBody.append('payTo', formData.payTo ? formData.payTo.value : '');
    requestBody.append('bptype', formData.bpType ? formData.bpType.value : '');
    requestBody.append('emailAddress', formData.emailAddress);
    requestBody.append('panNumber', formData.panNumber);
    requestBody.append('aadharNumber', formData.aadharNumber.replace(/\s/g, '')); // Removes any spaces from aadhar number
    requestBody.append('salesOfficerName', formData.salesOfficerName);
    requestBody.append('agencyCode', formData.agencyCode ? formData.agencyCode.value : '');
  //  requestBody.append('division', formData.division ? formData.division.value : '');
    requestBody.append('transportName', formData.transportName ? formData.transportName.value : '');
    requestBody.append('courierName', formData.courierName ? formData.courierName.value : '');
    requestBody.append('transportDestinationFrom', formData.transportDestinationFrom ? formData.transportDestinationFrom.value : '');
    requestBody.append('transportDestinationTo', formData.transportDestinationTo);
    requestBody.append('maxCaseOneLr', formData.maxCaseOneLr ? formData.maxCaseOneLr.value : '');
    requestBody.append('customerCategory', formData.customerCategory ? formData.customerCategory.value : '');
    requestBody.append('bankName', formData.bankName);
    requestBody.append('bankBranchAddress', formData.bankBranchAddress);
    requestBody.append('bankAccountNumber', formData.bankAccountNumber);
    requestBody.append('ifscCode', formData.ifscCode);
    requestBody.append('micrCode', formData.micrCode);

    // Append files (GST, PAN, Aadhar) if they exist
    if (formData.uploaded_file_gst) {
      requestBody.append('uploaded_file_gst', formData.uploaded_file_gst);
    }

    if (formData.uploaded_file_pan) {
      requestBody.append('uploaded_file_pan', formData.uploaded_file_pan);
    }

    if (formData.uploaded_file_aadhar) {
      requestBody.append('uploaded_file_aadhar', formData.uploaded_file_aadhar);
    }

    // Make API request
    const response = await bodycontentFormData(requestBody, 'customerprofile.php');

    console.log(response);

    // Handle the API response
    return await handleApiResponse(response);
  } catch (error) {
    // Handle any network or response errors
    throw handleNetworkError(error);
  }
};

const getCustomerProfileDetails = async (gstInNumber, panNumber = '') => {
  try {
    const response = await bodycontent(`gstInNumber=${gstInNumber}&panNumber=${panNumber}`, 'customerprofiledetails.php');

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const sendExtendCustomerProfileData = async (userCode, email, gstin, pan,division) => {
  try {
    const response = await bodycontent(
      `usercode=${userCode}&mailid=${email}&gstInNumber=${gstin}&panNumber=${pan}&division=${division}`,
      'customerprofiledetails.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const sampleCheckScanData = async (partyCode, userCode, verticalId, multiBarcode = '') => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    let filename = 'samplecheck.php';

    const response = await bodycontent(
      `partyCode=${partyCode}&userCode=${userCode}&verticalId=${verticalId}&div=${user.confSpart}&multiBarcode=${multiBarcode}`,
      filename
    );
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};
const stockUpload = async (fileInput, userCode) => {
  try {
    const formData = new FormData();
    formData.append('uploaded_file', fileInput);
    formData.append('userCode', userCode);
    const response = await uplaodbodycontent(formData, 'Admin/barcodeCsvUpload.php');
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};
const uplaodbodycontent = (body, url) => {
  if (!navigator.onLine) {
    throw new Error('No internet connection. Please check your network settings.');
  }
  return fetch(BASE_URL + url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      ...getAuthHeaders()
    },
    body: body

    //  timeout:TIMEOUT_DURATION
  });
};

const salesOrderUpload = async (fileInput) => {
  try {
    // const location=JSON.parse(localStorage.getItem('location'));
    const user = JSON.parse(localStorage.getItem('user'));
    const confvalue = JSON.parse(localStorage.getItem('confvalue'));
    let orderType;
    if (user.userVerticalId.toLowerCase().includes(GARMENTUSER.toLowerCase())) {
      orderType = 'garment';
    } else {
      orderType = 'fabric';
    }
    const formData = new FormData();
    formData.append('uploaded_file', fileInput);
    formData.append('userCode', user.userCode);
    formData.append('userId', user.userId);
    formData.append('cId', confvalue.cID);
    formData.append('verticalId', user.userVerticalId);
    formData.append('orderType', orderType);
    // formData.append('orderLatitude', location.latitude);
    // formData.append('orderLongitude', location.longitude);
    // formData.append('orderLocation', location.address);

    const response = await uplaodbodycontent(formData, 'saleOrderUploadCsv.php');
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const cancelOrderAPI = async (orderId, userCode) => {
  try {
    const response = await bodycontent(`orderId=${orderId}&userCode=${userCode}`, 'cancelOrder.php');
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getLedgerData = async (partyCode) => {
  try {
    const response = await bodycontent(`partyCode=${partyCode}`, 'ledger.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getLedgerDivData = async (partyCode, verticalId, profitCenter, isSFA) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));

    const response = await bodycontent(
      `userCode=${user.userCode}&partyCode=${partyCode}&userVertical=${verticalId}&profitCenter=${profitCenter}&isSFA=${isSFA}`,
      'ledgerDiv.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};
const getPreviousDivWiseLedgerData = async (partyCode, verticalId, profitCenter, isSFA) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));

    const response = await bodycontent(
      `userCode=${user.userCode}&partyCode=${partyCode}&userVertical=${verticalId}&profitCenter=${profitCenter}&isSFA=${isSFA}`,
      'previousDivWiseLedger.php'
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getVendorLedgerData = async (partyCode) => {
  try {
    const response = await bodycontent(`partyCode=${partyCode}`, 'partyvendorledger.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getLedgerDetails = async (partyCode, month, year, opening) => {
  try {
    const response = await bodycontent(`partyCode=${partyCode}&month=${month}&year=${year}&opening=${opening}`, 'ledgerDetails.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getLedgerDivDetails = async (partyCode, month, year, opening, userVertical, profitCenter, isSFA) => {
  try {
    // const profitCentersArr = profitCenters.join(',');

    const response = await bodycontent(
      `partyCode=${partyCode}&month=${month}&year=${year}&opening=${opening}&userVertical=${userVertical}&profitCenter=${profitCenter}&isSFA=${isSFA}`,
      'ledgerDivDetails.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getLedgerDivDetailsCPI = async (partyCode, verticalId, profitCenter, isSFA) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));

    const response = await bodycontent(
      `userCode=${user.userCode}&partyCode=${partyCode}&userVertical=${verticalId}&profitCenter=${profitCenter == null || profitCenter === 'null' || profitCenter === 'undefined' ? '' : profitCenter}&isSFA=${isSFA}`,
      'LedgerDivDetailsCPI.php'
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getPreviousDivWiseLedgerDetails = async (partyCode, month, year, opening, userVertical, profitCenter, isSFA) => {
  try {
    const response = await bodycontent(
      `partyCode=${partyCode}&month=${month}&year=${year}&opening=${opening}&userVertical=${userVertical}&profitCenter=${profitCenter}&isSFA=${isSFA}`,
      'previousDivWiseLedgerDetails.php'
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getPreviousLedgerData = async (partyCode) => {
  try {
    const response = await bodycontent(`partyCode=${partyCode}`, 'previousledger.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};
const getPreviousLedgerDetails = async (partyCode, month, year, opening) => {
  try {
    const response = await bodycontent(
      `partyCode=${partyCode}&month=${month}&year=${year}&opening=${opening}`,
      'previousledgerDetails.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getVendorLedgerDetails = async (partyCode, month, year, opening) => {
  try {
    const response = await bodycontent(
      `partyCode=${partyCode}&month=${month}&year=${year}&opening=${opening}`,
      'partyvendorledgerDetails.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const downloadFiles = async (param, url, filename) => {
  try {
    const response = await fetch(BASE_URL + url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...getAuthHeaders()
      },
      credentials: 'include',
      body: param
    });

    if (!response.ok) {
      await handleUnauthorizedResponse(response);
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // console.log(response);
    const blob = await response.blob();

    // Create a link element and trigger a download
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const stockDownload = async (param, url, filename) => {
  try {
    const response = await fetch(BASE_URL + url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...getAuthHeaders()
      },
      credentials: 'include',
      body: param
    });

    if (!response.ok) {
      await handleUnauthorizedResponse(response);
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // console.log(response);
    const blob = await response.blob();

    // Create a link element and trigger a download
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const pendingOrdersDownload = async (param, url, filename) => {
  try {
    const response = await fetch(BASE_URL + url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...getAuthHeaders()
      },
      credentials: 'include',
      body: param
    });

    if (!response.ok) {
      await handleUnauthorizedResponse(response);
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // console.log(response);
    const blob = await response.blob();

    // Create a link element and trigger a download
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const pincodeData = async (pincode) => {
  try {
    const response = await bodycontent(`pincode=${pincode}`, 'postalpincode.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getAssessmentScanData = async (multiBarcode = '', verticalId) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    let filename = 'scan_assessment.php';
    const response = await bodycontent(`div=${user.confSpart}&verticalId=${verticalId}&multiBarcode=${multiBarcode}`, filename);
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const addAssessmentScanData = async (payloaddata) => {
  try {
    let filename = 'add_assessment.php';
    const response = await bodycontent(`data=${payloaddata}`, filename);
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDivisionWiseOutstanding = async (partyCode, profitCenter,userVerticalId, isSFA) => {
  try {
    const response = await bodycontent(
      `partyCode=${partyCode}&profitCenter=${profitCenter}&userVertical=${userVerticalId}&isSFA=${isSFA}`,
      'outstanding.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDivisionWiseOutstandingCPI = async (partyCode, profitCenter,userVerticalId, isSFA) => {
  try {
    console.log("profitCenter:", profitCenter);
    const response = await bodycontent(
      `partyCode=${partyCode}&profitCenter=${profitCenter == null || profitCenter === 'null' || profitCenter === 'undefined' ? '' : profitCenter}&userVertical=${userVerticalId}&isSFA=${isSFA}`,
      'outstandingCPI.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDivisionWiseOutstandingNew = async (partyCode, profitCenter,confvertical, isSFA) => {
  try {
    const response = await bodycontent(
      `partyCode=${partyCode}&profitCenter=${profitCenter}&userVertical=${confvertical}&isSFA=${isSFA}`,
      'divisionWiseOutstanding.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDivisionWiseOutstandingNewCPI = async (partyCode, profitCenter,confvertical, isSFA) => {
  try {
    const response = await bodycontent(
      `partyCode=${partyCode}&profitCenter=${profitCenter == null || profitCenter === 'null' || profitCenter === 'undefined' ? '' : profitCenter}&userVertical=${confvertical}&isSFA=${isSFA}`,
      'divisionWiseOutstandingCPI.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getAssessmentReports = async (conferenceId, userCode) => {
  try {
    const response = await bodycontent(`conferenceId=${conferenceId}&userCode=${userCode}`, 'getAssessmentsList.php');

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Show planed beats
const fetchUserBeats = async (userCode, selectedDate) => {
  try {
    const response = await bodycontent(`user_code=${userCode}&date=${selectedDate}`, 'beats/fetchuserbeats.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Show beats for planning
const fetchPlanningBeats = async (userCode) => {
  try {
    const response = await bodycontent(`user_code=${userCode}`, 'beats/fetchuserplanningbeats.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchBeatCustomers = async (beatCode, userCode) => {
  try {
    const response = await bodycontent(`beat_code=${beatCode}&user_code=${userCode}`, 'beats/fetchcustomerdetails.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Upload Beats plan
const uploadBeatPlanning = async (beatCodes, selectedDateList, userCode) => {
  try {
    // Create form-encoded body
    const formData = new URLSearchParams();
    formData.append('user_code', userCode);

    // Append beats[] values
    beatCodes.forEach((beat) => formData.append('beats[]', beat));

    // Append dates[] values
    selectedDateList.forEach((date) => {
      const parts = date.split('/');
      if (parts.length === 3) {
        const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`; // yyyy-mm-dd
        formData.append('dates[]', formattedDate);
      } else {
        formData.append('dates[]', date); // fallback if not in expected format
      }
    });

    const response = await bodycontent(formData.toString(), 'beats/planuservisits.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const uploadBeatCustomerVisitRemark = async (
  userCode,
  beatCode,
  partyCode,
  visitStatus,
  visitRemark,
  visitDate,
  latitude,
  longitude,
  location,
  selectedPlant,
  user_type
) => {
  try {
    // const response = await bodycontent(`user_code=${userCode}&beat_code=${beatCode}&party_code=${partyCode}&visit_status=${visitStatus}&visit_remarks=${visitRemark}&visit_date=${visitDate}&latitude=${latitude}&longitude=${longitude}&location=${location}`, 'beats/insertvisitstatus.php');
    const response = await bodycontent(
      `user_code=${userCode}&beat_code=${beatCode}&party_code=${partyCode}&visit_status=${visitStatus}&visit_remarks=${visitRemark}&visit_date=${visitDate}&latitude=${latitude}&longitude=${longitude}&location=${location}&visitplantid=${selectedPlant}&user_type=${user_type}`,
      'beats/insertvisitstatus.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchBeatCustomerOutstandingReport = async (userCode, partyCode) => {
  try {
    const response = await bodycontent(`userCode=${userCode}&partyCode=${partyCode}`, 'reports/outstanding_report.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchBeatCustomerSalesCompReport = async (userCode, partyCode) => {
  try {
    const response = await bodycontent(`user_code=${userCode}&party_code=${partyCode}`, 'reports/sales_comparison_report.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchBeatCustomerCategoryCompReport = async (userCode, partyCode) => {
  try {
    const response = await bodycontent(`user_code=${userCode}&party_code=${partyCode}`, 'reports/category_wise_sales_report.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchKpiDivisionWiseSalesReport = async (userCode, partyCode = '') => {
  try {
    const response = await bodycontent(`user_code=${userCode}&party_code=${partyCode}`, 'reports/category_wise_sales_report.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchTargetSaleReport = async (userCode, partyCode) => {
  try {
    const response = await bodycontent(`user_code=${userCode}&party_code=${partyCode}`, 'reports/targetsales_report.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchProfitCenters = async (profitCenters) => {
  try {
    const response = await bodycontent(`profit_centers=${profitCenters}`, 'getProfitCenters.php');

    return await handleApiResponse(response);
    // return response;
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchPlantVisit = async () => {
  try {
    const response = await bodycontent(``, 'beats/getplantvisitlist.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

//Market Intelliagence
const fetchSubject = async () => {
  try {
    const response = await bodycontent(``, 'beats/getsubject.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}
const fetchDivision = async () => {
  try {
    const response = await bodycontent(``, 'getDivisionDropdown.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}
const fetchUserDivision = async (userCode = '') => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const resolvedUserCode = userCode || user?.userCode || '';
    const response = await bodycontent(`userCode=${resolvedUserCode}`, 'reports/getUserDivisionDropdown.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}
const fetchUsers = async (search) => {
  try {
    const response = await bodycontent(`search=${search}`, 'searchUser.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}

const getSalesPersonList = async (searchUsingCodeName = '', userCode = '') => {
  try {
    const response = await bodycontent(
      `searchUsingCodeName=${encodeURIComponent(searchUsingCodeName)}&userCode=${encodeURIComponent(userCode)}`,
      'tourexpenseclaim/salesPersonList.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getSalesManagerL1List = async (searchUsingCodeName = '', userCode = '') => {
  try {
    const response = await bodycontent(
      `searchUsingCodeName=${encodeURIComponent(searchUsingCodeName)}&userCode=${encodeURIComponent(userCode)}`,
      'tourexpenseclaim/salesOfficerList.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const insertTourExpenseClaim = async (formValues) => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const requestBody = new FormData();

    requestBody.append('agencyCode', user?.userCode || '');
    requestBody.append('fromDate', formValues.fromDate || '');
    requestBody.append('toDate', formValues.toDate || '');
    requestBody.append('salespersonCode', formValues.salespersonCode || '');
    requestBody.append('salesOfficerCode', formValues.salespersonL1Code || '');
    requestBody.append('modeOfTransport', formValues.modeOfTransport || '');
    requestBody.append('vehicleNumber', formValues.vehicleNumber || '');
    requestBody.append('totalKilometers', formValues.totalKilometersTravelled || '');
    requestBody.append('fromStation', formValues.fromStation || '');
    requestBody.append('midStations', formValues.midStations || '');
    requestBody.append('toStation', formValues.toStation || '');
    requestBody.append('ratePerKilometer', formValues.ratePerKilometer || '');
    requestBody.append('totalAmount', formValues.totalAmount || '');
    requestBody.append('travelAgencyCode', formValues.travelingAgency || '');
    requestBody.append('accountHolderName', formValues.accountHolderName || '');
    requestBody.append('bankName', formValues.bankName || '');
    requestBody.append('branchName', formValues.branchName || '');
    requestBody.append('bankAccountNumber', formValues.bankAccountNumber || '');
    requestBody.append('ifscCode', formValues.ifscCode || '');
    requestBody.append('hrTourProgramReferenceNo', formValues.hrOneReferenceNumber || '');
    requestBody.append('fullTourFromDate', formValues.fullTourFromDate || '');
    requestBody.append('fullTourToDate', formValues.fullTourToDate || '');

    if (formValues.invoiceFile) {
      requestBody.append('invoiceFile', formValues.invoiceFile);
    }

    const response = await bodycontentFormData(requestBody, 'tourexpenseclaim/insertTourExpenseClaim.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const insertSalesPersonVisit = async (requestBody) => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const selectedBrands = requestBody
      .getAll('brand[]')
      .filter(Boolean);
    requestBody.delete('brand[]');
    if (selectedBrands.length > 0) {
      requestBody.append('brands', selectedBrands.join(','));
    }
    requestBody.set('userCode', user?.userCode || '');

    const response = await bodycontentFormData(requestBody, 'createSalesPersonVisit.php');
    const data = await handleApiResponse(response);
    const isSuccess = data?.success === true || data?.success === 'true';

    if (!response.ok || !isSuccess) {
      throw new Error(data?.msg || `Unable to save the visit entry (HTTP ${response.status}).`);
    }

    return data;
  } catch (error) {
    if (error?.message) {
      throw error;
    }
    throw new Error('Unable to save the visit entry.');
  }
};

const downloadSalesPersonVisitEntryReport = async ({ retailerName = '', fromDate = '', toDate = '' } = {}) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const params = new URLSearchParams({ userCode: user?.userCode || '', retailerName, fromDate, toDate });
  const response = await fetch(`${BASE_URL}salesPersonVisitEntryReportDownload.php`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    body: params.toString()
  });

  if (!response.ok) {
    await handleUnauthorizedResponse(response);
    throw new Error(`Unable to download report (HTTP ${response.status}).`);
  }

  const blob = await response.blob();
  const contentDisposition = response.headers.get('Content-Disposition') || '';
  const filenameMatch = contentDisposition.match(/filename\*?=(?:UTF-8''|[\"])?([^;\"]+)/i);
  const filename = filenameMatch?.[1] ? decodeURIComponent(filenameMatch[1]) : 'sales-person-visit-report.csv';
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(link.href);
};

const fetchSalesPersonVisitEntryReport = async ({ retailerName = '', fromDate = '', toDate = '', page = 1, limit = 20 } = {}) => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const params = new URLSearchParams({
      userCode: user?.userCode || '',
      retailerName,
      fromDate,
      toDate,
      page: String(page),
      limit: String(limit)
    });
    const response = await bodycontent(params.toString(), 'salesPersonVisitEntryReport.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getAgentTourExpenseList = async (filters = {}, page = 1, limit = 100) => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const params = new URLSearchParams();

    params.append('userCode', user?.userCode || '');
    params.append('userType', getTourExpenseUserType(user));
    params.append('page', String(page));
    params.append('limit', String(limit));
    params.append('salespersonCode', filters.salespersonCode || '');
    params.append('salesOfficerCodeL1', filters.salespersonL1Code || '');
    params.append('travelAgencyCode', filters.travelingAgency || '');
    params.append('approvalStatus', filters.status || '');
    params.append('fromCreatedDate', filters.fromDate || '');
    params.append('toCreatedDate', filters.toDate || '');
    params.append('hrTourProgramReferenceNo', filters.hrOneReferenceNumber || '');

    const response = await bodycontent(params.toString(), 'tourexpenseclaim/tourClaimExpenseList.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const updateClaimApprovalStatus = async ({
  claimID,
  approvalStatus,
  reimbursementPercentage,
  remarks
}) => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const params = new URLSearchParams();

    params.append('claimID', String(claimID || ''));
    params.append('userCode', user?.userCode || '');
    params.append('userType', getTourExpenseUserType(user));
    params.append('approvalStatus', approvalStatus || '');
    params.append('reimbursementPercentage', reimbursementPercentage || '');
    params.append('remarks', remarks || '');

    const response = await bodycontent(params.toString(), 'tourexpenseclaim/updateClaimApprovalStatus.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getTourExpenseClaimHistory = async (claimID) => {
  try {
    const params = new URLSearchParams();
    params.append('claimID', String(claimID || ''));

    const response = await bodycontent(params.toString(), 'tourexpenseclaim/tourClaimEpenseHistory.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const createDisplayAndEventsRequest = async (formValues) => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const params = new URLSearchParams();
    const displayAndEventsFields = [
      'eventname',
      'registersrno',
      'division',
      'requestdate',
      'startdate',
      'enddate',
      'eventtype',
      'participatingareas',
      'expectedsalesqty',
      'expectedsalesamount',
      'expecteddealersno',
      'expectedretailersno',
      'customeravgdaystay',
      'expectedagentsno',
      'staffavgdaystay',
      'expectedstaffno',
      'hotelcostperperson',
      'hoteltotalcost',
      'travelcostperperson',
      'traveltotalcost',
      'displaycost',
      'logisticscost',
      'photovideoshootcost',
      'totalestimatedcost',
      'expenditurepercentage',
      'expenditurepercustomer',
      'existingscheme',
      'additionalscheme',
      'schemerate',
      'schemefrom',
      'schemeupto',
      'dresscostperperson',
      'dressstaffcount',
      'dressstafftotalcost',
      'dressagentscount',
      'dressagentstotalcost',
      'giftitem',
      'giftcostperitem',
      'giftquantity',
      'gifttotalcost'
    ];

    params.append('userCode', user?.userCode || formValues?.userCode || '');

    displayAndEventsFields.forEach((fieldName) => {
      params.append(fieldName, formValues?.[fieldName] || '');
    });

    const agenciesPayload = JSON.stringify(
      (formValues?.agencyRows || []).map((row) => ({
        agencytype: row?.agencyType || '',
        purpose: row?.purpose || '',
        amount: row?.amount || ''
      }))
    );
    params.append('agencies', agenciesPayload);

    const response = await bodycontent(params.toString(), 'displayandevents/createeventrequest.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDisplayAndEventsAgencyPurposeMaster = async () => {
  try {
    const response = await bodycontent('', 'displayandevents/viewAgencyPurposeMaster.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDisplayAndEventsAreasZonesDropdown = async () => {
  try {
    const response = await bodycontent('', 'displayandevents/viewAreasZonesDropdown.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDisplayAndEventsRequests = async (userCode = '', filters = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('userCode', userCode || '');
    params.append('eventName', filters?.eventname || '');
    params.append('division', filters?.division || '');
    params.append('fromDate', filters?.fromDate || '');
    params.append('toDate', filters?.toDate || '');
    params.append('status', filters?.status || '');
    params.append('page', String(filters?.page || 1));
    params.append('pageSize', String(filters?.pageSize || 100));

    const response = await bodycontent(params.toString(), 'displayandevents/vieweventrequests.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDisplayAndEventsAreaSalesManagers = async (searchUsingCodeName = '', userCode = '') => {
  try {
    const params = new URLSearchParams();
    params.append('searchUsingCodeName', searchUsingCodeName || '');
    params.append('userCode', userCode || '');

    const response = await bodycontent(params.toString(), 'displayandevents/areasalesmanager.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDisplayAndEventsHistory = async (eventid = '') => {
  try {
    const params = new URLSearchParams();
    params.append('eventid', eventid || '');

    const response = await bodycontent(params.toString(), 'displayandevents/displayandeventshistory.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const postMarketIntelliagence = async (formData) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const requestBody = new FormData();

    // Append form fields to FormData
    requestBody.append('user_code', user.userCode);
    requestBody.append('subject_id', formData.subject.value);
    requestBody.append('division', formData.division);
    requestBody.append('handover_person_code', formData.user);
    requestBody.append('remark', formData.remark);
    requestBody.append('price_cost_meter', formData.price_cost_meter || "");
    requestBody.append('physical_item_collected', formData.isPhysicalItemCollected);

    if (formData.uploaded_file && formData.uploaded_file.length > 0) {
      formData.uploaded_file.forEach((file, idx) => {
        requestBody.append(`file${idx + 1}`, file); // file1, file2, file3
      });
    }

    // Make API request
    const response = await bodycontentFormData(requestBody, 'beats/insertmarketintelligence.php');

    // Handle the API response
    return await handleApiResponse(response);
  } catch (error) {
    // Handle any network or response errors
    throw handleNetworkError(error);
  }
};

const ProductCatalogueCSVUpload = async (fileInput, userCode) => {
  try {
    const formData = new FormData();
    formData.append('file', fileInput);
    formData.append('user_code', userCode);

    // ✅ Correct backend URL
    const response = await uplaodbodycontent(formData, 'pdf/uploadproductcatalogcsv.php');


    // ✅ Handle non-200 responses
    if (!response.ok) {
      await handleUnauthorizedResponse(response);
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // ✅ Convert to Blob (binary data for PDF)
    const blob = await response.blob();

    // ✅ Extract filename from Content-Disposition header (if provided)
    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = 'ProductCatalog.pdf';
    if (contentDisposition && contentDisposition.includes('filename=')) {
      filename = contentDisposition.split('filename=')[1].replace(/["']/g, '');
    }

    // ✅ Trigger download in browser
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return {
      success: 'true',
      msg: 'Product Catalogue Uploaded Successfully',
    };
  } catch (error) {
    console.error('Error uploading or downloading file:', error);

    return {
      success: 'false',
      msg: 'Failed to upload Product Catalogue',
    };
  }
};

const fetchUserReports = async () => {
  // try {
  //   const response = await bodycontent(`user_code=${userCode}&party_code=${partyCode}`, 'beats/category_wise_sales_report.php');
  //   return await handleApiResponse(response);
  // } catch (error) {
  //   throw handleNetworkError(error);
  // }
};

// REPORT APIs
// Target vs Achievement API
const fetchTargetAchievementReport = async (userCode) => {
  try {
    const response = await bodycontent(`party_code=${userCode}`, 'targetAchievementReports.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Collections API
const fetchCollectionsReport = async (userCode) => {
  try {
    const response = await bodycontent(`party_code=${userCode}`, 'collectionsReport.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Pending vs Dispatch API
const fetchPendingDispatchReport = async (userCode) => {
  try {
    const response = await bodycontent(`party_code=${userCode}`, 'pendingDispatchReports.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Pending vs Dispatch API
const fetchOutstandingReport = async (userCode) => {
  try {
    const response = await bodycontent(`party_code=${userCode}`, 'outstandingReport.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Pending vs Dispatch API
const fetchSalesReport = async (userCode) => {
  try {
    const response = await bodycontent(`party_code=${userCode}`, 'salesReport.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Stock Level API
const fetchStockLevelReport = async (userCode) => {
  try {
    const response = await bodycontent(`party_code=${userCode}`, 'stockLevel.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Sample Request APIs
// get Barcode Data
const fetchSampleRequestBarcodesData = async (userId, barcode, userCode, verticalId, multiBarcode, mainGroup) => {
  console.log('fetchSampleRequestBarcodesData api Design Number in Controller-----', mainGroup);
  try {
    const payload = new URLSearchParams();
    payload.append('userId', userId || '');
    payload.append('barcode', barcode || '');
    payload.append('userCode', userCode || '');
    payload.append('verticalId', verticalId || '');
    payload.append('multiBarcode', multiBarcode || '');
    payload.append('mainGroup', mainGroup || '');

    const response = await bodycontent(payload.toString(), 'sampleRequestBarcodescan.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};
const fetchSalesPlanningBarcodesData = async (userId, barcode, userCode, verticalId, multiBarcode, mainGroup) => {
  console.log('fetchSampleRequestBarcodesData api Design Number in Controller-----', mainGroup);
  try {
    const payload = new URLSearchParams();
    payload.append('userId', userId || '');
    payload.append('barcode', barcode || '');
    payload.append('userCode', userCode || '');
    payload.append('verticalId', verticalId || '');
    payload.append('multiBarcode', multiBarcode || '');
    payload.append('mainGroup', mainGroup || '');

    const response = await bodycontent(payload.toString(), 'salesPlanningBarcodescan.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// fetch Sample Types
const fetchSampleTypes = async () => {
  try {
    const response = await bodycontent(``, 'sampleType.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

//sample request order
const proceedsamplerequestorder = async ({
  userCode,
  apId,
  partyCode,
  conferenceId,
  sampleCategory,
  remark,
  isReplicate = 0,
  sampleRequestReplicateRefNo = '',
  sampleRequestOrderId = '',
  sampleOrderDetailsListArray
}) => {
  try {
    const body =
      `userCode=${encodeURIComponent(userCode)}` +
      `&apId=${encodeURIComponent(apId)}` +
      `&partyCode=${encodeURIComponent(partyCode)}` +
      `&conferenceId=${encodeURIComponent(conferenceId)}` +
      `&sampleCategory=${encodeURIComponent(sampleCategory)}` +
      `&remark=${encodeURIComponent(remark)}` +
      `&isReplicate=${encodeURIComponent(isReplicate)}` +
      `&sampleRequestReplicateRefNo=${encodeURIComponent(sampleRequestReplicateRefNo)}` +
      `&sampleRequestOrderId=${encodeURIComponent(sampleRequestOrderId)}` +
      `&sampleOrderDetailsListArray=${encodeURIComponent(
        JSON.stringify(sampleOrderDetailsListArray) // JSON object → string
      )}`;

    console.log("FINAL BODY →", body);
    const response = await bodycontent(body, "sampleRequestOrder.php");
    return await response.json();

  } catch (err) {
    console.error("API ERROR:", err);
    throw err;
  }
};

const submitSampleRequestRemarkAPI = async (sampleRequestId, remark) => {
  try {
    const response = await bodycontent(`samReqOrderId=${sampleRequestId}&remarks=${remark}`, 'pdf/sampleRequestOrderSavePdf.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getSampleRequestList = async ({
  page = 1,
  pageSize = 100,
  userCode = '',
  partyCode = '',
  fromDate = '',
  toDate = ''
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('pageSize', pageSize);
    params.append('userCode', userCode);
    params.append('partyCode', partyCode || '');
    params.append('date_from', fromDate || '');
    params.append('date_to', toDate || '');

    const response = await bodycontent(params.toString(), 'sampleRequestList.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getSampleRequestDetailsList = async (sampleRequestOrderId) => {
  try {
    const response = await bodycontent(
      `sampleRequestOrderId=${encodeURIComponent(sampleRequestOrderId || '')}`,
      'sampleRequestDetailsList.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const downloadSampleRequestPdf = async (samReqDocNo) => {
  try {
    const response = await fetch(BASE_URL + 'Admin/samplerequestpdfdownload.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...getAuthHeaders()
      },
      credentials: 'include',
      body: `samReqDocNo=${encodeURIComponent(samReqDocNo || '')}`
    });

    if (!response.ok) {
      await handleUnauthorizedResponse(response);
      throw new Error('Failed to download sample request document.');
    }

    const blob = await response.blob();
    const contentDisposition = response.headers.get('content-disposition');
    let filename = `${samReqDocNo || 'sample-request'}.pdf`;

    if (contentDisposition && contentDisposition.includes('filename=')) {
      filename = contentDisposition.split('filename=')[1].replace(/["']/g, '').trim();
    }

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);

    return {
      success: true,
      msg: 'Sample request document downloaded successfully.'
    };
  } catch (error) {
    throw handleNetworkError(error);
  }
};


// Stock selection Garment Ratio
const fetchRatioOptions = async (wearType) => {
  try {
    const response = await bodycontent(`wearType=${wearType}`, 'ratioOptions.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// fetch three months for sample request
const fetchSampleRequestMonths = async () => {
  try {
    const response = await bodycontent(``, 'getThreeMonthsAfterCurrentMonth.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const proceedsamplerequestorder90days = async ({
  userCode,
  conferenceId,
  remark,
  sampleOrderDetails90DayListArray
}) => {
  try {
    const body =
      `userCode=${encodeURIComponent(userCode)}` +
      `&conferenceId=${encodeURIComponent(conferenceId)}` +
      `&remark=${encodeURIComponent(remark)}` +
      `&sampleOrderDetails90DayListArray=${encodeURIComponent(
        JSON.stringify(sampleOrderDetails90DayListArray)
      )}`;

    // console.log("FINAL BODY →", body);
    const response = await bodycontent(body, "sampleRequest90DayOrder.php");
    // console.log('response api service-',response.message);
    // console.log('response api service-',response.success);
    return await handleApiResponse(response);

  } catch (err) {
    console.error("API ERROR:", err);
    throw err;
  }
};

// Pending vs Dispatch API
const postGoodAndReturns = async (usercode, value, label) => {
  try {
    const response = await bodycontent(`userCode=${usercode}&value=${value}&label=${label}`, 'processgoodsreturns.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Fetch Dynamic Report Data
const getSample90DaysMonthsReport = async (
  userCode,
  materialCodeOrItems,
  materialDesc,
  mainGroup,
  barcode
) => {
  try {
    let params = `userCode=${encodeURIComponent(userCode || '')}`;

    const reportItems = Array.isArray(materialCodeOrItems)
      ? materialCodeOrItems
      : [{
          materialCode: materialCodeOrItems || '',
          materialDesc: materialDesc || '',
          mainGroup: mainGroup || '',
          barcode: barcode || ''
        }];

    params += `&reportItems=${encodeURIComponent(JSON.stringify(
      reportItems.map((item) => ({
        materialCode: item?.materialCode || '',
        materialDesc: item?.materialDesc || '',
        mainGroup: item?.mainGroup || '',
        barcode: item?.barcode || ''
      }))
    ))}`;

    const response = await bodycontent(params, 'sampleRequest90DaysReport.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const CheckoutSampleRequest = async (sampleRequestOrderId, remark) => {
  const user = JSON.parse(localStorage.getItem('user'));

  try {
    const response = await bodycontent(
      `userCode=${user.userCode}&sampleRequestOrderId=${sampleRequestOrderId}&remark=${remark}`,
      'sampleRequestOrderCheckout.php'
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getSampleRequestAccessAPI = async (userCode, conferenceId) => {
  try {
    const response = await bodycontent(`userCode=${userCode}&conferenceId=${conferenceId}`, 'checksamplerequest90daysaccess.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// fetch user parties
const fetchUserParties = async (userCode) => {
  try {
    const response = await bodycontent(`userCode=${userCode}`, 'getUserReportsPartyCodes.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// upload Goods Return Info
const uploadGoodsReturnInfoDetails = async (formData) => {
  try {
    const requestBody = new FormData();

    // --------------------
    // Goods Return Info
    // --------------------
    requestBody.append('return_option', formData.return_option);
    requestBody.append('order_number', formData.order_number);
    requestBody.append('user_code', formData.user_code);
    requestBody.append('party_code', formData.party_code);
    requestBody.append('from_party_code', formData.from_party_code);
    requestBody.append('delivery_number', formData.delivery_number);
    requestBody.append('invoice_number', formData.invoice_number);
    requestBody.append('invoice_date', formData.invoice_date);
    requestBody.append('materialInfoListArray', JSON.stringify(formData.materialInfoDetails));

    // --------------------
    // Transfer Details
    // --------------------
    // ✅ JSON string for material list
    // requestBody.append(
    //   'materialInfoListArray',
    //   JSON.stringify({
    //     materialInfoDetails: formData.materialInfoDetails.map(item => ({
    //       material_code: item.material_code,
    //       material_description: item.material_desc,
    //       barcode: item.barcode,
    //       quantity: item.quantity,
    //       batch: item.batch,
    //     })),
    //   })
    // );

    // --------------------
    // Files (PDF)
    // --------------------
    // if (formData.lr_copy) {
    //   requestBody.append('lr_copy', formData.lr_copy); // File object
    // }

    // if (formData.debit_note_copy) {
    //   requestBody.append('debit_note_copy', formData.debit_note_copy); // File object
    // }

    // --------------------
    // API CALL
    // --------------------
    const response = await bodycontentFormData(
      requestBody,
      'goods_return_info.php'
    );

    return await handleApiResponse(response);

  } catch (error) {
    throw handleNetworkError(error);
  }
}

// submit goods return transfer details
const uploadGoodsReturnTransferDetails = async (formData) => {

  try {
    const requestBody = new FormData();

    // --------------------
    // Goods Return Info
    // --------------------
    requestBody.append('deliveryNo', formData.deliveryNumber);
    // requestBody.append('return_option', formData.return_option);
    // requestBody.append('order_number', formData.order_number);
    requestBody.append('user_code', formData.user_code);
    requestBody.append('party_code', formData.party_code);
    requestBody.append('from_party_code', formData.from_party_code);
    // requestBody.append('deliveryNo', formData.delivery_number);
    requestBody.append('invoice_number', formData.invoice_number);
    requestBody.append('goodsReturnInvoiceDtlsId', formData.goodsReturnInvoiceDtlsId);
    // requestBody.append('invoice_date', formData.invoice_date);
    // requestBody.append('barcode', formData.barcode);
    // requestBody.append('quantity', formData.quantity);
    // requestBody.append('material_code', formData.material_code);
    // requestBody.append('material_description', formData.material_description);
    // requestBody.append('batch', formData.batch);

    // --------------------
    // Transfer Details
    // --------------------
    requestBody.append('lr_number', formData.lr_number);
    requestBody.append('lr_date', formData.lr_date);
    requestBody.append('transporter', formData.transporter);
    requestBody.append('e_way_bill', formData.e_way_bill);
    requestBody.append('discount_percentage', formData.discount_percentage || 0);

    // --------------------
    // Files (PDF)
    // --------------------
    if (formData.lr_copy) {
      requestBody.append('lr_copy', formData.lr_copy); // File object
    }

    if (formData.debit_note_copy) {
      requestBody.append('debit_note_copy', formData.debit_note_copy); // File object
    }

    // --------------------
    // API CALL
    // --------------------
    const response = await bodycontentFormData(
      requestBody,
      'goods_return_transfer.php'
    );

    return await handleApiResponse(response);

  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchZonesPOReports = async (userCode, type = "collection") => {
  try {
    const response = await bodycontent(`userCode=${userCode}&type=${type}`, 'reports/zones.php');
    console.log('zone dropdown', response)
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}

const fetchZonePartiesPOReports = async (userCode, { search = "", type = "collection", zone = "" }) => {
  try {
    const response = await bodycontent(`userCode=${userCode}&search=${search}&type=${type}&zone=${zone}`, 'reports/zoneparties.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}

const fetchDescriptionPOReports = async (userCode) => {
  try {
    const response = await bodycontent(`userCode=${userCode}`, 'reports/descriptions.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}

const fetchSubdivisionPOReports = async (userCode, type = "collection") => {
  try {
    const response = await bodycontent(`userCode=${userCode}&type=${type}`, 'reports/subdivision.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}

const fetchPendingOrderReports = async (
  userCode,
  page,
  zone,
  partyCode,
  division,
  status,
  description,
  fromDate,
  toDate
) => {
  const params =
    `userCode=${encodeURIComponent(userCode)}` +
    `&page=${encodeURIComponent(page)}` +
    `&zone=${encodeURIComponent(zone || "")}` +
    `&partyCode=${encodeURIComponent(partyCode || "")}` +
    `&division=${encodeURIComponent(division || "")}` +
    `&status=${encodeURIComponent(status || "")}` +
    `&description=${encodeURIComponent(description || "")}` +
    `&from_date=${encodeURIComponent(fromDate || "")}` +
    `&to_date=${encodeURIComponent(toDate || "")}`;

  const response = await bodycontent(params, "reports/pendingorderreport.php");
  return handleApiResponse(response);
};

const downloadPendingOrderReport = async (
  userCode,
  page,
  zone,
  partyCode,
  division,
  status,
  description,
  fromDate,
  toDate
) => {
  const params =
    `userCode=${encodeURIComponent(userCode)}` +
    `&page=${encodeURIComponent(page)}` +
    `&zone=${encodeURIComponent(zone || "")}` +
    `&partyCode=${encodeURIComponent(partyCode || "")}` +
    `&division=${encodeURIComponent(division || "")}` +
    `&status=${encodeURIComponent(status || "")}` +
    `&description=${encodeURIComponent(description || "")}` +
    `&from_date=${encodeURIComponent(fromDate || "")}` +
    `&to_date=${encodeURIComponent(toDate || "")}`;

  return pendingOrdersDownload(
    params,
    "reports/pendingOrderReportDownload.php",
    `pending_order_report_${new Date().toISOString().slice(0, 10)}.xls`
  );
};

const fetchOutstandingReports = async (
  userCode,
  page,
  zone,
  division,
  partyCode,
  fromDate,
  toDate
) => {
  const params =
    `userCode=${encodeURIComponent(userCode)}` +
    `&page=${encodeURIComponent(page)}` +
    `&zone=${encodeURIComponent(zone || "")}` +
    `&division=${encodeURIComponent(division || "")}` +
    `&party=${encodeURIComponent(partyCode || "")}` +
    `&from_date=${encodeURIComponent(fromDate || "")}` +
    `&to_date=${encodeURIComponent(toDate || "")}`;

  const response = await bodycontent(params, "reports/outstandingreport.php");
  return handleApiResponse(response);
};

const fetchNonBilledReports = async (
  userCode,
  customerCode,
  division,
  fromDate,
  toDate
) => {
  const params =
    `userCode=${encodeURIComponent(userCode || "")}` +
    `&customer_code=${encodeURIComponent(customerCode || "")}` +
    `&division=${encodeURIComponent(division || "")}` +
    `&from_date=${encodeURIComponent(fromDate || "")}` +
    `&to_date=${encodeURIComponent(toDate || "")}`;

  const response = await bodycontent(params, "nonBilledReportCsvDownload.php");
  return handleApiResponse(response);
};


const fetchAllConferenceList = async () => {
  try {
    const response = await bodycontent(``, 'conferencelist.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}

const fetchCollectionReceivedReports = async (
  userCode,
  page,
  zone,
  partyCode,
  fromDate,
  toDate,
  year,
  month
) => {
  const params =
    `userCode=${encodeURIComponent(userCode)}` +
    `&page=${encodeURIComponent(page)}` +
    `&zone=${encodeURIComponent(zone || "")}` +
    `&party=${encodeURIComponent(partyCode || "")}` +
    `&from_date=${encodeURIComponent(fromDate || "")}` +
    `&to_date=${encodeURIComponent(toDate || "")}` +
    `&year=${encodeURIComponent(year || "")}` +
    `&month=${encodeURIComponent(month || "")}`;
  console.log('collection params', params);
  const response = await bodycontent(params, "reports/collectionreceived.php");
  return handleApiResponse(response);

}

const getAllCustomerDataByCID = async (cID) => {
  try {
    const response = await bodycontent(`cId=${cID}`, 'get_agents_by_conference.php');
    console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchSFASizeForOrgDivision = async (division) => {
  try {
    const response = await bodycontent(`orgDiv=${division}`, 'orgDivSizexList.php');
    console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchAllGoodsReturnInfo = async (userCode, deliveryNumber, invoiceNumber) => {
  try {
    const response = await bodycontent(`userCode=${userCode}&deliveryNumber=${deliveryNumber}&invoiceNumber=${invoiceNumber}`, 'goods_return_invoice_details_list.php');
    console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchGoodsReturnMaterialList = async (goodsReturnInvoiceDtlsId) => {
  try {
    const response = await bodycontent(`goodsReturnInvoiceDtlsId=${goodsReturnInvoiceDtlsId}`, 'goods_return_info_list.php');
    console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchGoodsReturnStatusHistory = async (grInvoiceDtlsId) => {
  try {
    const response = await bodycontentnormal(`grInvoiceDtlsId=${grInvoiceDtlsId}`, 'getGoodsReturnStatusHistoryList.php');
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchMonthsDropdown = async (userCode, type = "collection") => {
  try {
    const response = await bodycontent(`userCode=${userCode}&type=${type}`, 'reports/monthsdropdown.php');
    console.log('months dropdown', response)
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}

const fetchDashboardReports = async (
  userCode,
  page,
  zone,
  partyCode,
  fromDate,
  toDate,
  zoneName
) => {
  const params =
    `userCode=${encodeURIComponent(userCode)}` +
    `&page=${encodeURIComponent(page)}` +
    `&zone=${encodeURIComponent(zone || "")}` +
    `&party=${encodeURIComponent(partyCode || "")}` +
    `&from_date=${encodeURIComponent(fromDate || "")}` +
    `&to_date=${encodeURIComponent(toDate || "")}` +
    `&zoneName=${encodeURIComponent(zoneName || "")}` +
    `&isProfile=0`;
  //   console.log('dashboard report params', params);
  const response = await bodycontent(params, "reports/dashboardreport.php");
  return handleApiResponse(response);

}

const fetchTopSalesQualityForStockBooking = async (userCode) => {
  const response = await fetchTop20SalesQualityReports(userCode);
  const list = Array.isArray(response?.topSalesQuality) ? response.topSalesQuality : [];
  return {
    status: Boolean(response?.status),
    topSalesQuality: list
  };
};

const fetchTop20SalesQualityReports = async (
  userCode
) => {
  const params =
    `userCode=${encodeURIComponent(userCode)}` +
    `&partyCode=${encodeURIComponent('')}`;
  //   console.log('dashboard report params', params);
  const response = await bodycontent(params, "reports/top20SalesQuality.php");
  return handleApiResponse(response);

}

const fetchCurrentMonthSalesReports = async (
  userCode,
  page,
  zone,
  divisions,
  partyCode,
  qualityPage,
  customerPage
) => {
  const params =
    `userCode=${encodeURIComponent(userCode)}` +
    `&page=${encodeURIComponent(page)}` +
    `&zone=${encodeURIComponent(zone || "")}` +
    `&subdivision=${encodeURIComponent(divisions || "")}` +
    `&party=${encodeURIComponent(partyCode || "")}` +
    `&qualityPage=${encodeURIComponent(qualityPage || "")}` +
    `&customerPage=${encodeURIComponent(customerPage || "")}` +
    `&customerLimit=${encodeURIComponent(100)}`;

  //   console.log('dashboard report params', params);
  const response = await bodycontent(params, "reports/currentmonthsalesfigure.php");
  return handleApiResponse(response);
};

const fetchAgencyDashboardReports = async ({
  userCode,
  pageSize = 100,
  area = "",
  month = "",
  division = "",
  budgetPage = 1,
  growthVolumePage = 1,
  growthValuePage = 1,
  currentQuarterPage = 1,
  lastQuarterPage = 1,
  dealerPage = 1,
  paymentPage = 1
}) => {
  const params =
    `userCode=${encodeURIComponent(userCode || "")}` +
    `&pageSize=${encodeURIComponent(pageSize || "")}` +
    `&area=${encodeURIComponent(area || "")}` +
    `&month=${encodeURIComponent(month || "")}` +
    `&division=${encodeURIComponent(division || "")}` +
    `&budgetPage=${encodeURIComponent(budgetPage || 1)}` +
    `&growthVolumePage=${encodeURIComponent(growthVolumePage || 1)}` +
    `&growthValuePage=${encodeURIComponent(growthValuePage || 1)}` +
    `&currentQuarterPage=${encodeURIComponent(currentQuarterPage || 1)}` +
    `&lastQuarterPage=${encodeURIComponent(lastQuarterPage || 1)}` +
    `&dealerPage=${encodeURIComponent(dealerPage || 1)}` +
    `&paymentPage=${encodeURIComponent(paymentPage || 1)}`;

  const response = await bodycontent(params, "reports/agencyDashboard.php");
  return handleApiResponse(response);
};


const checkBarcodeStock = async (barcode, materialDesc) => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const formData = new FormData();
    if (user?.userCode) formData.append("userCode", user.userCode);
    if (barcode) formData.append("barcode", barcode);
    if (materialDesc) formData.append("materialDesc", materialDesc);

    const response = await bodycontentFormData(formData, "barcodeValidInvalidUserDivisionWise.php");
    return await handleApiResponse(response);
  } catch (error) {
    console.error("checkBarcodeStock error:", error);
    throw handleNetworkError(error);
  }
};

const DownloadBarcodeValidInvalid = async (barcode, materialDesc) => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const formData = new FormData();
    if (user?.userCode) formData.append("userCode", user.userCode);
    if (barcode) formData.append("barcode", barcode);
    if (materialDesc) formData.append("materialDesc", materialDesc);

    const response = await fetch(BASE_URL + "downloadcsvBarcodeValidInvalidUserDivisionWise.php", {
      method: "POST",
      credentials: 'include',
      headers: {
        ...getAuthHeaders()
      },
      body: formData
    });

    if (!response.ok) {
      await handleUnauthorizedResponse(response);
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const blob = await response.blob();
    const fileURL = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = fileURL;
    link.download = "Barcode_Valid_Invalid_Report.xls";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(fileURL);

    return true;
  } catch (error) {
    console.error("DownloadBarcodeValidInvalid error:", error);
    throw handleNetworkError(error);
  }
};

const getDealerWisePerformanceReport = async (userCode, page = 1, limit = 100) => {
  try {
    const response = await bodycontentnormal(
      `userCode=${encodeURIComponent(userCode)}&page=${encodeURIComponent(page)}&limit=${encodeURIComponent(limit)}`,
      'reports/onePageDealerWisePerformanceReport.php'
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getRetailerNameByCustomer = async (userCode, customerCode) => {
  try {
    const response = await bodycontentnormal(
      `userCode=${encodeURIComponent(userCode)}&customerCode=${encodeURIComponent(customerCode)}`,
      'getRetailerNameFromCustomer.php'
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getOrderBookedQty = async (orderNumber) => {
  try {
    const response = await bodycontentnormal(
      `orderId=${encodeURIComponent(orderNumber)}`,
      'getOrderBookedQty.php'
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

export const getLedgerDetailsCPI = async (partyCode, profitCenter) => {
   try {
    const response = await bodycontentnormal(
      `partyCode=${encodeURIComponent(partyCode)}&profitCenter=${profitCenter == null || profitCenter === 'null' || profitCenter === 'undefined' ? '' : profitCenter}`,
      'ledgerDetailscpi.php'
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}

export {
  loginApi,
  logoutApi,
  fetchHeaderAnnouncement,
  forgotPassApi,
  otpVerificaionApi,
  resetPasswordApi,
  getConfData,
  getCustomerData,
  getCustomerStatusFromSap,
  getNonBilledCustomerData,
  getCustomerLeadgerData,
  getAgencyData,
  getDistributorData,
  getBarcodeScanData,
  insertSalesPerformanceBarcodeScan,
  updateSalesPerformanceBarcodeQuantityChecked,
  getSalesPerfomerDetailsList,
  getSalesPerfomerDetailsReportList,
  fetchSalesPerformanceReport,
  downloadSalesPerformerReportCsv,
  salesPerfomerBarcodeScanFabric,
  Order,
  getOrdersData,
  getOrderDetails,
  getReplicateOrderDetails,
  getRetriveDetails,
  CheckoutOrder,
  getOrderReasonData,
  FabricCheckoutOrder,
  downalodFabricPdf,
  attedancereportData,
  myordersreportData,
  getDenknitOrderList,
  getSecondarySalesOrderList,
  getSecondarySalesOrderDetails,
  updateSecondarySalesOrderStockType,
  createSalesOrderFromSecondary,
  getSecondarySalesBarcodeData,
  saveSecondarySalesOrder,
  getDenknitOrderDetails,
  approveDenknitOrderItem,
  getDenknitTimeline,
  updateDenknitCustomerApproval,
  getDenknitBarcodeScanData,
  saveDenknitOrder,
  checkDenknitApprovalStatus,
  DenknitCheckoutOrder,
  getTransportData,
  getCourierData,
  getDivisionData,
  getUserDivisionData,
  CustomerProfileApi,
  getCustomerProfileDetails,
  sendExtendCustomerProfileData,
  sampleCheckScanData,
  stockUpload,
  salesOrderUpload,
  cancelOrderAPI,
  getLedgerData,
  getVendorLedgerData,
  getVendorLedgerDetails,
  getPreviousLedgerDetails,
  getPreviousLedgerData,
  getLedgerDetails,
  getLedgerDivData,
  getLedgerDivDetails,
  getLedgerDivDetailsCPI,
  getPreviousDivWiseLedgerData,
  getPreviousDivWiseLedgerDetails,
  downloadFiles,
  checkBarcodeStock,
  DownloadBarcodeValidInvalid,
  stockDownload,
  pendingOrdersDownload,
  pincodeData,
  getAssessmentScanData,
  addAssessmentScanData,
  getDivisionWiseOutstanding,
  getDivisionWiseOutstandingCPI,
  getDivisionWiseOutstandingNew,
  getDivisionWiseOutstandingNewCPI,
  getAssessmentReports,
  fetchUserBeats,
  fetchPlanningBeats,
  fetchBeatCustomers,
  uploadBeatPlanning,
  uploadBeatCustomerVisitRemark,
  fetchBeatCustomerOutstandingReport,
  getSalesPerformerList,
  fetchBeatCustomerSalesCompReport,
  fetchBeatCustomerCategoryCompReport,
  fetchKpiDivisionWiseSalesReport,
  fetchProfitCenters,
  fetchPlantVisit,
  fetchSubject,
  fetchDivision,
  fetchUserDivision,
  fetchUsers,
  getSalesPersonList,
  getSalesManagerL1List,
  insertTourExpenseClaim,
  insertSalesPersonVisit,
  fetchSalesPersonVisitEntryReport,
  downloadSalesPersonVisitEntryReport,
  updateClaimApprovalStatus,
  getAgentTourExpenseList,
  getTourExpenseClaimHistory,
  createDisplayAndEventsRequest,
  getDisplayAndEventsAgencyPurposeMaster,
  getDisplayAndEventsAreasZonesDropdown,
  getDisplayAndEventsRequests,
  getDisplayAndEventsAreaSalesManagers,
  getDisplayAndEventsHistory,
  postMarketIntelliagence,
  ProductCatalogueCSVUpload,
  fetchUserReports,

  // User Reports APIs
  fetchTargetAchievementReport,
  fetchCollectionsReport,
  fetchPendingDispatchReport,
  fetchOutstandingReport,
  fetchSalesReport,
  fetchStockLevelReport,

  // Sample Request APIs
  fetchSampleRequestBarcodesData,
  fetchSampleTypes,
  proceedsamplerequestorder,
  submitSampleRequestRemarkAPI, // Submit remark,
  getSampleRequestList,
  getSampleRequestDetailsList,
  downloadSampleRequestPdf,
  fetchSampleRequestMonths,
  proceedsamplerequestorder90days,
  getSample90DaysMonthsReport,
  CheckoutSampleRequest,

  // Stock selection Garment Ratio
  fetchRatioOptions,
  postGoodAndReturns,
  getSampleRequestAccessAPI,

  // Goods return
  fetchUserParties,
  uploadGoodsReturnInfoDetails,
  uploadGoodsReturnTransferDetails,
  fetchAllGoodsReturnInfo,
  fetchGoodsReturnMaterialList,
  fetchGoodsReturnStatusHistory,

  fetchZonesPOReports,
  fetchDescriptionPOReports,
  fetchZonePartiesPOReports,
  fetchSubdivisionPOReports,
  fetchPendingOrderReports,
  downloadPendingOrderReport,
  fetchOutstandingReports,
  fetchNonBilledReports,
  fetchTargetSaleReport,
  fetchCollectionReceivedReports,
  fetchAllConferenceList,
  getAllCustomerDataByCID,
  getSalesOrderCustomerTargetData,
  getDealerWisePerformanceReport,

  fetchSFASizeForOrgDivision,
  fetchMonthsDropdown,
  fetchDashboardReports,
  fetchAgencyDashboardReports,
  fetchCurrentMonthSalesReports,
  fetchSalesPlanningBarcodesData,
  fetchTopSalesQualityForStockBooking,
  
  getRetailerNameByCustomer,
  getOrderBookedQty,
};







